import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useParams, useLocation } from 'react-router-dom';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, Alert, Container, Select, MenuItem, Typography, TextField, InputLabel, Button, Box, List, ListItem, ListItemText, IconButton, Modal, Card, CardContent, Grid, LinearProgress, Tabs, Tab, useMediaQuery
} from '@mui/material';
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplications';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AssignRoleOrTeam from '../components/AssignRoleorTeam';
import CreateTaskForm from '../components/CreateTaskForm';
import CreateSubtaskForm from '../components/CreateSubtaskForm';
import DetailsForm from '../components/DetailsForm';
import Pagination from '../components/Pagination';
import { useTheme } from '@mui/material/styles';
import '../App.css';
import { Pie, Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import AssignmentIcon from "@mui/icons-material/Assignment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import GroupIcon from "@mui/icons-material/Group";
import GroupsIcon from "@mui/icons-material/Groups";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import DashboardIcon from '@mui/icons-material/Dashboard';
import VisibilityIcon from '@mui/icons-material/Visibility';
import InfoIcon from '@mui/icons-material/Info';
import MenuIcon from '@mui/icons-material/Menu';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { useTranslation } from "react-i18next";


ChartJS.register(CategoryScale, // X ekseni için
  LinearScale,   // Y ekseni için
  BarElement, ArcElement, Tooltip, Legend);



const ProjectDetails = () => {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const [currentUserId, setCurrentUserId] = useState(null);

  const [tasks, setTasks] = useState([]);
  const [taskModalOpen, setTaskModalOpen] = useState(false);
  const [stats, setStats] = useState(null);
  const [project, setProject] = useState(null);
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteMessage, setInviteMessage] = useState('');
  const [teamName, setTeamName] = useState('');
  const [teamDescription, setTeamDescription] = useState('');
  const [teamMessage, setTeamMessage] = useState('');
  const [members, setMembers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [userRoleId, setUserRoleId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState('role');
  const [selectedMember, setSelectedMember] = useState(null);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [teamModalOpen, setTeamModalOpen] = useState(false);
  const [deleteMemberModalOpen, setDeleteMemberModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [expandedSubtasks, setExpandedSubtasks] = useState({});
  const [subtaskModalOpen, setSubtaskModalOpen] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [subtaskErrorMessage, setSubtaskErrorMessage] = useState('');
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // Mevcut sayfa numarası
  const itemsPerPage = 5; // Sayfa başına gösterilecek görev sayısı
  const [totalTasks, setTotalTasks] = useState(0); // Toplam görev sayısı
  const [totalPages, setTotalPages] = useState(1); // Toplam sayfa sayısı

  const [currentSubtaskPage, setCurrentSubtaskPage] = useState({}); // Görev ID'sine göre sayfa numaralarını tutar
  const subTaskitemsPerPage = 5; // Sayfa başına gösterilecek alt görev sayısı
  const [hasPermission, setHasPermission] = useState(false);

  const location = useLocation(); // URL'deki query parametrelerini al
  const [activeTab, setActiveTab] = useState(null);
  const [detailsTab, setDetailsActiveTab] = useState('details');
  const navigate = useNavigate();
  const [isManager, setIsManager] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isPermittedToAddSubtask, setPermittedToSubtask] = useState(false);
  const [loading, setLoading] = useState(true);

  // State tanımları
  const [personalTasks, setPersonalTasks] = useState([]);
  const [teamTasks, setTeamTasks] = useState([]);
  const [otherTasks, setOtherTasks] = useState([]);
  const [allTasks, setAllTasks] = useState([]);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [overdueTasks, setOverdueTasks] = useState([]);
  const [personalTasksPage, setPersonalTasksPage] = useState(1);
  const [teamTasksPage, setTeamTasksPage] = useState(1);
  const [otherTasksPage, setOtherTasksPage] = useState(1);
  const [allTasksPage, setAllTasksPage] = useState(1);
  const [completedTasksPage, setCompletedTasksPage] = useState(1);
  const [overdueTasksPage, setoverdueTasksPage] = useState(1);
  const [totalPersonalTasks, setTotalPersonalTasks] = useState(0);
  const [totalTeamTasks, setTotalTeamTasks] = useState(0);
  const [totalOtherTasks, setTotalOtherTasks] = useState(0);
  const [totalAllTasks, setTotalAllTasks] = useState(0);
  const [totalCompletedTasks, setTotalCompletedTasks] = useState(0);
  const [totalOverdueTasks, setTotalOverdueTasks] = useState(0);
  const [pManagerUserTasksPage, setPManagerUserTasksPage] = useState(1);
  const [pManagerteamTasksPage, setPManagerTeamTasksPage] = useState(1);
  const [totalPManagerUserTasks, setTotalPManagerUserTasks] = useState(0);
  const [totalPManagerteamTasks, setTotalPManagerteamTasks] = useState(0);
  const [pmTeamTasks, setPMTeamTasks] = useState([]);
  const [pmUserTasks, setPMUserTasks] = useState([]);
  const [subtaskMainTaskTeamId, setSubtaskMainTaskTeamId] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);

  const [expenses, setExpenses] = useState([]);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [expenseTaskList, setExpenseTaskList] = useState([]);
  const [selectedExpenseTask, setSelectedExpenseTask] = useState(null);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [newExpenseName, setNewExpenseName] = useState('');
  const [newExpenseAmount, setNewExpenseAmount] = useState('');
  const [isEditingBudget, setIsEditingBudget] = useState(false);
  const [budgetLimit, setBudgetLimit] = useState('');
  const [currency, setCurrency] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(''); // Seçili kategori
  const [newCategoryName, setNewCategoryName] = useState('');   // Yeni kategori adı
  const [addingNewCategory, setAddingNewCategory] = useState(false); // Yeni kategori ekleme durumu
  const [openDeleteExpenseDialog, setOpenDeleteExpenseDialog] = useState(false);
  const [expensesModalOpen, setExpensesModalOpen] = useState(false);

  const [newRiskName, setNewRiskName] = useState('');
  const [newRiskLikelihood, setNewRiskLikelihood] = useState('');
  const [newRiskImpact, setNewRiskImpact] = useState('');
  const [selectedRisk, setSelectedRisk] = useState(null);
  const [selectedRiskCategory, setSelectedRiskCategory] = useState('');
  const [newRiskDescription, setNewRiskDescription] = useState('');
  const [riskTaskList, setRiskTaskList] = useState([]);
  const [selectedRiskTask, setSelectedRiskTask] = useState('');
  const [risksModalOpen, setRisksModalOpen] = useState(false);
  const [openDeleteRiskDialog, setOpenDeleteRiskDialog] = useState(false);
  const [risks, setRisks] = useState([]);
  const [riskCategories, setRiskCategories] = useState([]);
  const [newRiskCategoryName, setNewRiskCategoryName] = useState('');   // Yeni kategori adı
  const [addingNewRiskCategory, setAddingNewRiskCategory] = useState(false); // Yeni kategori ekleme durumu
  const [editingRiskId, setEditingRiskId] = useState('');
  const [updatedRisk, setUpdatedRisk] = useState({});
  const statusOptions = ['Open', 'In Progress', 'Mitigated', 'Resolved', 'Accepted', 'Closed'];


  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });


  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleSelectChange = (event) => {
    setActiveTab(event.target.value);
  };

  const [currentPages, setCurrentPages] = useState({
    personal: 1,
    team: 1,
    other: 1,
    pmuser: 1,
    pmteam: 1,
    all: 1,
    overdue: 1,
    completed: 1
  });

  // Sayfa numarası değiştirildiğinde tetiklenecek fonksiyon
  const handlePageChange = (tab, newPage) => {
    setExpandedSubtasks({});
    setCurrentPages((prevPages) => ({
      ...prevPages,
      [tab]: newPage,
    }));
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (userRoleId === 1) {
      setActiveTab('all');
    } else if (userRoleId === 2 || userRoleId === 3) {
      setActiveTab('personal');
    }
  }, [userRoleId]);

  useEffect(() => {
    // Proje rolünü kontrol etmek için checkPermission fonksiyonunu çağır
    checkPermission(projectId, setHasPermission);
  }, [projectId]);
  // URL'den `task` ve `tab` parametrelerini alalım
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const taskId = params.get('task'); // Task ID
    const subtaskId = params.get('subtask'); // Subtask ID
    const tab = params.get('tab'); // Tab (comments, files, vb.)

    if (taskId && !subtaskId) {
      // Eğer `taskId` varsa, ilgili görevi yükle
      fetchTask(taskId); // Görev detaylarını yükle
      setSelectedSubtask(null); // Alt görev varsa temizle
    }

    if (taskId && subtaskId) {
      // Eğer `subtaskId` varsa, ilgili alt görevi yükle
      fetchSubtask(subtaskId); // Alt görev detaylarını yükle
      setSelectedTask(null); // Görev varsa temizle
    }

    if (tab) {
      setDetailsActiveTab(tab); // Tab parametresi varsa aktif sekmeyi güncelle
    }
  }, [location.search]);

  // Görev detaylarını yükleme fonksiyonu
  const fetchTask = async (taskId) => {
    try {
      const response = await api.get(`/api/tasks/${taskId}/detail`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setSelectedTask(response.data); // Görev detaylarını `selectedTask` state'ine ata
      setDetailsModalOpen(true); // Modalı aç
    } catch (error) {

    }
  };

  // Alt görev detaylarını yükleme fonksiyonu
  const fetchSubtask = async (subtaskId) => {
    try {
      const response = await api.get(`/api/subtasks/${subtaskId}/detail`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setSelectedSubtask(response.data); // Alt görev detaylarını `selectedSubtask` state'ine ata
      setDetailsModalOpen(true); // Modalı aç
    } catch (error) {

    }
  };

  const handleAccordionToggle = (taskId) => {
    setExpandedSubtasks((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };

  const handleOpenDeleteMemberModal = (memberId) => {
    setSelectedMember(memberId);
    setDeleteMemberModalOpen(true);
  };

  const handleCloseDeleteMemberModal = () => {
    setDeleteMemberModalOpen(false);
  };

  const fetchTeams = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/teams/${projectId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTeams(response.data);
    } catch (error) {

    }
  };

  const fetchProject = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/projects/${projectId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProject(response.data);
      fetchExpenses();
      fetchCategories();
      fetchRisks();
      fetchRiskCategories();


      const membersResponse = await api.get(`/api/projects/${projectId}/members`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const membersWithRoles = membersResponse.data.map(member => ({
        ...member,
        roleId: member.projectRoles && member.projectRoles.length > 0 ? member.projectRoles[0].roleId : 'No Role'
      }));
      setMembers(membersWithRoles);

      if (response.data.managerId === response.data.currentUserId) {
        setIsManager(true);
      } else {
        setIsManager(false);
      }
      setCurrentUserId(response.data.currentUserId);

      if (isManager) {
        setUserRoleId(1);
      } else {

        fetchUserRole(projectId, token);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {

        localStorage.removeItem('token'); // Token'ı sil
        localStorage.removeItem('user');
        navigate('/login'); // Kullanıcıyı login sayfasına yönlendir

      }
      else if (error.response?.status === 403) {
        alert(t("access_denied"));
        navigate('/projects'); // Kullanıcıyı genel proje sayfasına yönlendir
      }
    }
  };

  const fetchUserRole = async (projectId, token) => {
    try {
      // API isteğini yap
      const roleResponse = await api.get(`/api/projects/${projectId}/role`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      //console.log("rol " + roleResponse.data.roleId);
      setUserRoleId(roleResponse.data.roleId)
    } catch (error) {
      // Hata oluşursa yanıtı veya hata mesajını yazdır

    }
  };

  // All Tasks fetch function
  const fetchAllTasks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/tasks/project/${projectId}?page=${currentPages.all}&limit=${itemsPerPage}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setAllTasks(response.data.tasks);
      setTotalAllTasks(response.data.totalTasks);
    } catch (error) {

    }
  };

  // Completed Tasks fetch function
  const fetchCompletedTasks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/tasks/project/${projectId}/completed?page=${currentPages.completed}&limit=${itemsPerPage}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCompletedTasks(response.data.tasks); // Gelen `completed` görevleri set et
      setTotalCompletedTasks(response.data.totalTasks); // Toplam `completed` görev sayısını set et
    } catch (error) {

    }
  };


  // Overdue Tasks fetch function
  const fetchOverdueTasks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/tasks/project/${projectId}/overdue?page=${currentPages.overdue}&limit=${itemsPerPage}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setOverdueTasks(response.data.tasks); // Gelen `overdue` görevleri set et
      setTotalOverdueTasks(response.data.totalTasks); // Toplam `overdue` görev sayısını set et
    } catch (error) {

    }
  };




  // Personal Tasks fetch function
  const fetchPersonalTasks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/tasks/project/${projectId}/tasks/personal?page=${currentPages.personal}&limit=${itemsPerPage}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setPersonalTasks(response.data.tasks);
      setTotalPersonalTasks(response.data.totalTasks);
    } catch (error) {

    }
  };

  // Team Tasks fetch function
  const fetchTeamTasks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/tasks/project/${projectId}/tasks/team?page=${currentPages.team}&limit=${itemsPerPage}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setTeamTasks(response.data.tasks);
      setTotalTeamTasks(response.data.totalTasks);
    } catch (error) {

    }
  };

  // Other Tasks fetch function
  const fetchOtherTasks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/tasks/project/${projectId}/tasks/other?page=${currentPages.other}&limit=${itemsPerPage}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setOtherTasks(response.data.tasks);
      setTotalOtherTasks(response.data.totalTasks);
    } catch (error) {

    }
  };

  const fetchPManagerUserTasks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/tasks/projects/${projectId}/user-assigned-tasks?page=${currentPages.pmuser}&limit=${itemsPerPage}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPMUserTasks(response.data.tasks);
      setTotalPManagerUserTasks(response.data.totalTasks);
    } catch (error) {

    }
  };

  const fetchPManagerTeamTasks = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/tasks/projects/${projectId}/team-assigned-tasks?page=${currentPages.pmteam}&limit=${itemsPerPage}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPMTeamTasks(response.data.tasks);
      setTotalPManagerteamTasks(response.data.totalTasks);
    } catch (error) {

    }
  };

  const refreshTasks = async (taskId, subtaskId = null) => {
    if (subtaskId) {

      // Eğer subtask güncellendiyse yalnızca ilgili subtasks listesini güncelle
      await fetchSubtasks(taskId, currentSubtaskPage[taskId]);
    } else {
      // Aktif sekmeye göre tüm görevleri güncelle
      switch (activeTab) {
        case 'personal':
          await fetchPersonalTasks();
          break;
        case 'team':
          await fetchTeamTasks();
          break;
        case 'other':
          await fetchOtherTasks();
          break;
        case 'pmuser':
          await fetchPManagerUserTasks();
          break;
        case 'pmteam':
          await fetchPManagerTeamTasks();
          break;
        case 'all':
          await fetchAllTasks();
          break;
        case 'completed':
          await fetchCompletedTasks();
          break;
        case 'overdue':
          await fetchOverdueTasks();
          break;
        default:
          console.warn('Unknown active tab:', activeTab);
      }
    }
  };




  const fetchSubtasks = async (xtaskId, page = 1, limit = 5) => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/subtasks/${xtaskId}/subtasks?page=${page}&limit=${limit}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data && response.data.subtasks) {
        // Görevleri güncellerken uygun sekmeye göre alt görevleri ekle
        if (activeTab === 'personal') {
          setPersonalTasks((prevTasks) => {
            const updatedTasks = prevTasks.map(task =>
              task.id === xtaskId ? { ...task, subtasks: response.data.subtasks, totalSubtasks: response.data.totalSubtasks, currentPage: response.data.currentPage } : task
            );

            return [...updatedTasks];
          });
        } else if (activeTab === 'team') {
          setTeamTasks((prevTasks) => {
            const updatedTasks = prevTasks.map(task =>
              task.id === xtaskId ? { ...task, subtasks: response.data.subtasks, totalSubtasks: response.data.totalSubtasks, currentPage: response.data.currentPage } : task
            );

            return [...updatedTasks];
          });
        } else if (activeTab === 'other') {
          setOtherTasks((prevTasks) => {
            const updatedTasks = prevTasks.map(task =>
              task.id === xtaskId ? { ...task, subtasks: response.data.subtasks, totalSubtasks: response.data.totalSubtasks, currentPage: response.data.currentPage } : task
            );

            return [...updatedTasks];
          });
        } else if (activeTab === 'pmuser') {
          setPMUserTasks((prevTasks) => {
            const updatedTasks = prevTasks.map(task =>
              task.id === xtaskId ? { ...task, subtasks: response.data.subtasks, totalSubtasks: response.data.totalSubtasks, currentPage: response.data.currentPage } : task
            );

            return [...updatedTasks];
          });
        } else if (activeTab === 'pmteam') {
          setPMTeamTasks((prevTasks) => {
            const updatedTasks = prevTasks.map(task =>
              task.id === xtaskId ? { ...task, subtasks: response.data.subtasks, totalSubtasks: response.data.totalSubtasks, currentPage: response.data.currentPage } : task
            );

            return [...updatedTasks];
          });
        } else if (activeTab === 'all') {
          setAllTasks((prevTasks) => {
            const updatedTasks = prevTasks.map(task =>
              task.id === xtaskId ? { ...task, subtasks: response.data.subtasks, totalSubtasks: response.data.totalSubtasks, currentPage: response.data.currentPage } : task
            );

            return [...updatedTasks];
          });
        } else if (activeTab === 'overdue') {
          setOverdueTasks((prevTasks) => {
            const updatedTasks = prevTasks.map(task =>
              task.id === xtaskId ? { ...task, subtasks: response.data.subtasks, totalSubtasks: response.data.totalSubtasks, currentPage: response.data.currentPage } : task
            );

            return [...updatedTasks];
          });
        } else if (activeTab === 'completed') {
          setCompletedTasks((prevTasks) => {
            const updatedTasks = prevTasks.map(task =>
              task.id === xtaskId ? { ...task, subtasks: response.data.subtasks, totalSubtasks: response.data.totalSubtasks, currentPage: response.data.currentPage } : task
            );

            return [...updatedTasks];
          });
        }

      } else {
        console.error('Subtask verisi bulunamadı:', response.data);
      }
    } catch (error) {
      console.error('Error fetching subtasks:', error);
    }
  };

  const handleSubtaskPageChange = (taskId, newPage) => {
    setCurrentSubtaskPage((prevPages) => ({
      ...prevPages,
      [taskId]: newPage,
    }));
    fetchSubtasks(taskId, newPage, subTaskitemsPerPage);
  };



  const fetchStats = async () => {
    try {
      //console.log("fetchStats çalışıyor...");
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/projects/${projectId}/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // console.log("API Response:", response.data);
      setStats(response.data); // State set ediliyor
    } catch (error) {

    }
  };

  useEffect(() => {
    //console.log("useEffect çalışıyor...");
    fetchProject();
    //fetchTeams();
    fetchStats(); // Stats çağrısı buradan tetikleniyor
  }, [projectId]);



  useEffect(() => {
    if (activeTab === 'personal' && projectId) {
      console.log("personal");
      fetchPersonalTasks();
    } else if (activeTab === 'team' && projectId) {
      console.log("team");
      fetchTeamTasks();
    } else if (activeTab === 'other' && projectId) {
      console.log("other");
      fetchOtherTasks();
    } else if (activeTab === 'pmuser' && projectId) {
      console.log("pmuser");
      fetchPManagerUserTasks();
    } else if (activeTab === 'pmteam' && projectId) {
      console.log("pmteam");
      fetchPManagerTeamTasks();
    } else if (activeTab === 'all' && projectId) {
      console.log("all");
      fetchAllTasks();
    } else if (activeTab === 'completed' && projectId) {
      console.log("completed");
      fetchCompletedTasks();
    } else if (activeTab === 'overdue' && projectId) {
      console.log("overdue");
      fetchOverdueTasks();
    }
  }, [activeTab, currentPages, projectId, personalTasksPage, teamTasksPage, otherTasksPage, pManagerUserTasksPage, pManagerteamTasksPage]);


  const handleInvite = async (event) => {
    event.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await api.post(`/api/projects/${projectId}/invite`, { email: inviteEmail }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setInviteMessage(t("invitation_sent"));
      setInviteEmail('');
      setInviteModalOpen(false);
    } catch (error) {
      setInviteMessage(t("invitation_failed") + (error.response?.data?.error || error.message));
    }
  };

  const handleCreateTeam = async (event) => {
    event.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await api.post(`/api/projects/${projectId}/teams`, { name: teamName, description: teamDescription }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTeamMessage(t("team_created_success"));
      setTeamName('');
      setTeamDescription('');
      setTeamModalOpen(false);
      fetchTeams();
    } catch (error) {
      setTeamMessage(t("team_creation_failed") + (error.response?.data?.error || error.message));
    }
  };


  const confirmDeleteMember = async () => {
    try {
      const token = localStorage.getItem('token');
      await api.delete(`/api/projects/${projectId}/members/${selectedMember}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMembers(members.filter((member) => member.id !== selectedMember));
      handleCloseDeleteMemberModal();
    } catch (error) {

    }
  };



  const handleOpenModal = (type, id = null) => {
    setModalType(type);
    setSelectedMember(id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setTaskModalOpen(false);
  };

  const [selectedTeamId, setSelectedTeamId] = useState(null);



  const confirmDeleteTeam = async () => {
    try {
      const token = localStorage.getItem('token');
      await api.delete(`/api/teams/${selectedTeamId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchTeams();
      handleCloseModal();
    } catch (error) {

    }
  };

  const handleEditTeam = async (event) => {
    event.preventDefault();
    if (!selectedTeamId) {

      return;
    }

    try {
      const token = localStorage.getItem('token');
      await api.patch(`/api/teams/${selectedTeamId}`, {
        name: teamName,
        description: teamDescription,
        projectId: projectId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchTeams();
      handleCloseModal();
    } catch (error) {

    }
  };

  const [teamMembers, setTeamMembers] = useState([]);

  const fetchTeamMembers = async (teamId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get(`/api/teams/${teamId}/members`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTeamMembers(response.data);
    } catch (error) {

    }
  };





  const handleCreateSubtask = async (newSubtask) => {
    try {
      setSelectedSubtask(newSubtask);
      await fetchSubtasks(newSubtask.task_id, currentSubtaskPage[newSubtask.task_id]);

      /*setExpandedSubtasks((prev) => ({
        ...prev,
        [newSubtask.task_id]: !prev[newSubtask.task_id],
      }));*/
    } catch (error) {

      setSubtaskErrorMessage(error.response?.data?.error || 'Failed to create subtask');
    }
  };


  const handleCreateSubtaskClick = (task) => {
    setSelectedTask(task);
    setSelectedSubtask(null);
    setSubtaskModalOpen(true);
  };




  const handleCloseSubtaskModal = async () => {

    //await fetchSubtasks(selectedSubtask.task_id, currentSubtaskPage[selectedSubtask.task_id]);
    setSubtaskModalOpen(false);
    setSelectedSubtask(null);
    //handleSubtaskAccordionToggle(selectedTask.taskId);
  };



  const handleSubtaskAccordionToggle = async (taskId) => {
    setExpandedSubtasks({ [taskId]: !expandedSubtasks[taskId] }); // Seçilen görev hariç diğer tüm görevlerin alt görevlerini kapat

    if (!expandedSubtasks[taskId]) {
      // Alt görevleri fetch etmek ve expanded state'i güncellemek
      await fetchAuthorization(taskId);
      await fetchSubtasks(taskId);
    }
  };




  // Task için details modalini açan fonksiyon
  const handleOpenTaskDetailsModal = (task) => {
    setSelectedTask(task);  // Seçili task'ı ayarla
    setSubtaskMainTaskTeamId(null);
    setSelectedSubtask(null);  // Subtask'ı sıfırla
    setDetailsModalOpen(true);  // Modal'i aç
  };

  // Subtask için details modalini açan fonksiyon
  const handleOpenSubtaskDetailsModal = (subtask, _subtaskMainTaskTeamId) => {
    setSelectedSubtask(subtask);  // Seçili subtask'ı ayarla
    console.log(subtask);
    setSubtaskMainTaskTeamId(_subtaskMainTaskTeamId);
    setSelectedTask(null);  // Task'ı sıfırla
    setDetailsModalOpen(true);  // Modal'i aç
  };


  // Modalı kapatan fonksiyon
  const handleCloseDetailsModal = () => {
    setDetailsModalOpen(false);  // Modal'i kapat
    setSelectedTask(null);  // Seçili olan görevi sıfırla
  };

  const progressPercentage = stats?.totalTasks > 0 ? ((stats?.completedTasks || 0) / stats?.totalTasks) * 100 : 0;


  const checkPermission = async (projectId, setHasPermission) => {
    try {
      const response = await api.get(`/api/projects/${projectId}/roleandteams`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });

      const { roleId, managedTeams } = response.data;
      console.log(managedTeams);
      console.log(roleId);
      // Sadece roleId 1 veya 2 olanlar yetkiye sahip
      if (roleId === 1 || (roleId === 2 && managedTeams?.length > 0)) {
        if (managedTeams?.length > 0) {
          setTeams(managedTeams);
        }
        else {
          fetchTeams();
        }

        setHasPermission(true);
      } else {
        setHasPermission(false);
      }
    } catch (error) {

      setHasPermission(false); // Hata durumunda izni kapat
    }
  };


  const checkUserRoleAndAssignment = async (taskId, userId) => {
    try {
      const response = await api.get(`/api/tasks/${projectId}/${taskId}/checkUserRole`, {
        params: { userId },
      });
      console.log(response.data);
      return response.data;
    } catch (error) {

      return null;
    }
  };


  const fetchAuthorization = async (taskId) => {
    console.log("isManager: " + isManager);
    if (isManager) {
      setIsAuthorized(true);
      setPermittedToSubtask(true);
    }
    else {
      console.log("check");
      const result = await checkUserRoleAndAssignment(taskId, currentUserId);
      if (result) {
        const { roleId, isAssignedToTask, isPartOfAssignedTeam, isTeamManager } = result;
        console.log(roleId, isAssignedToTask, isPartOfAssignedTeam, isTeamManager);
        // Kullanıcının yetkili olup olmadığını kontrol et
        if (roleId === 1 || (roleId === 2 && (isAssignedToTask || isTeamManager))) {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
        if (roleId === 1 || (roleId === 2 && (isTeamManager))) {
          setPermittedToSubtask(true);
        } else {
          setPermittedToSubtask(false);
        }
      } else {
        setIsAuthorized(false);
      }
    }
  };

  const scrollToTasks = (tab) => {
    setActiveTab(tab);
    const tasksSection = document.getElementById("tasks-section");
    if (tasksSection) {
      tasksSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleDelete = async (type, id) => {
    try {
      setIsProcessing(true);
      const token = localStorage.getItem('token');
      const response = await api.delete(`/api/projects/delete/${type}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessage({
        text: response?.data?.message ?? t(`messages.${type === 'task' ? 'taskDeleted' : 'subtaskDeleted'}`),
        type: 'success',
      });
      setOpen(false);
      // Aktif sekmeye göre ilgili grubu güncelle
      // Eğer silinen bir subtask ise bağlı olduğu görev ID'sine göre alt görevleri yenile
      if (type === 'subtask' && selectedSubtask?.task_id) {
        await fetchSubtasks(selectedSubtask.task_id);
      } else {
        // Aktif sekmeye göre ilgili grubu güncelle
        switch (activeTab) {
          case 'personal':
            fetchPersonalTasks();
            break;
          case 'team':
            fetchTeamTasks();
            break;
          case 'other':
            fetchOtherTasks();
            break;
          case 'pmuser':
            fetchPManagerUserTasks();
            break;
          case 'pmteam':
            fetchPManagerTeamTasks();
            break;
          case 'all':
            fetchAllTasks();
            break;
          case 'completed':
            fetchCompletedTasks();
            break;
          case 'overdue':
            fetchOverdueTasks();
            break;
          default:
            console.warn('Unknown active tab:', activeTab);
        }
      }
    } catch (error) {
      console.error('Error deleting:', error.message);
      setMessage({
        text: error.response?.data?.error ?? t('messages.deleteFailed'),
        type: 'error',
      });
    } finally {
      setIsProcessing(false);
    }
  };

  const handleOpenDeleteModal = (type, item) => {
    if (type === 'task') {
      setSelectedTask(item);
      setSelectedSubtask(null);
    } else if (type === 'subtask') {
      setSelectedSubtask(item);
      setSelectedTask(null);
    }
    setOpen(true);
    setMessage(''); // Önceki mesajı temizle
  };


  const handleAddExpense = async () => {
    try {
      await api.post(
        `/api/expenses`,
        {
          project_id: projectId,
          description: newExpenseName,
          amount: newExpenseAmount,
          category_id: selectedCategory,
          task_id: selectedExpenseTask,
          created_by: currentUserId
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );
      setNewExpenseName('');
      setNewExpenseAmount('');
      setSelectedCategory('');
      fetchExpenses(); // Yeni harcamayı listeye eklemek için tekrar yükle
    } catch (error) {

    }
  };


  const handleAddCategory = async () => {
    if (!newCategoryName.trim()) {
      alert(t("category_name_empty"));
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await api.post(
        '/api/expenseCategories',
        {
          name: newCategoryName,
          project_id: projectId, // Proje ID'si backend ile uyumlu şekilde gönderiliyor
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Yeni kategoriyi mevcut kategoriler listesine ekle
      setExpenseCategories((prevCategories) => [...prevCategories, response.data]);

      // Kullanıcıya bilgi ver ve seçili kategoriyi yeni kategori olarak ayarla
      alert(t("category_added"));
      setSelectedCategory(response.data.id);
      setAddingNewCategory(false);
      // TextField temizle
      setNewCategoryName('');
    } catch (error) {

      alert(t("add_category_failed"));
    }
  };


  const handleSaveBudget = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error(t('errors.authTokenNotFound'));
      }

      if (!budgetLimit || isNaN(budgetLimit)) {
        throw new Error(t('errors.invalidBudgetValue'));
      }

      console.log(`Updating project ${projectId} with budget limit: ${budgetLimit}`);

      // PUT isteğiyle bütçe ve para birimi güncellemesi
      await api.put(
        `/api/projects/${projectId}`,
        { total_budget: parseFloat(budgetLimit), currency: currency || 'USD' },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Başarılı güncelleme sonrası düzenleme modunu kapat ve proje bilgilerini yenile
      setIsEditingBudget(false);
      await fetchProject();
      console.log('Budget updated successfully.');
    } catch (error) {
      // Hata durumunda kullanıcıya bilgi ve loglama
      console.error('Error updating budget:', error.message || error);
      alert(t('messages.budgetUpdateFailed'));
    }
  };



  const fetchExpenses = async () => {
    try {
      const response = await api.get(`/api/expenses/${projectId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      console.log(response.data);
      setExpenses(response.data);
    } catch (error) {

    }
  };

  const fetchTasksforExpenseList = async () => {
    try {
      const response = await api.get(`/api/tasks/expenseTasks/${projectId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      console.log(response.data);
      setExpenseTaskList(response.data);
      setRiskTaskList(response.data); // riskler için de ayrı bir task listesi oluşturalım.
    } catch (error) {

    }
  };

  const fetchCategories = async () => {
    try {
      const response = await api.get(`/api/expenseCategories/${projectId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      console.log(response.data);
      setExpenseCategories(response.data); // Kategorileri state'e aktar
    } catch (error) {

    }
  };

  const fetchRiskCategories = async () => {
    try {
      const response = await api.get(`/api/riskCategories/${projectId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      console.log(response.data);
      setRiskCategories(response.data); // Kategorileri state'e aktar
    } catch (error) {

    }
  };

  const fetchRisks = async () => {
    try {
      const response = await api.get(`/api/risks/${projectId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      console.log(response.data);
      setRisks(response.data);
    } catch (error) {

    }
  };

  // Modal açıldığında fetchExpenses çağrılır
  useEffect(() => {
    if (expensesModalOpen) {
      fetchExpenses();
      fetchCategories(); // Kategorileri de yükleyelim
      fetchTasksforExpenseList();
    }
  }, [expensesModalOpen]);

  useEffect(() => {
    if (risksModalOpen) {
      fetchRisks();
      fetchRiskCategories(); // Kategorileri de yükleyelim
      fetchTasksforExpenseList(); // aynı fonksiyon olduğu için riskler için de çağırıyorum
    }
  }, [risksModalOpen]);


  const handleClose = () => {
    setOpen(false);
    setSelectedTask(null);
    setSelectedSubtask(null);
    setMessage(''); // Modal kapandığında mesajı temizle
  };

  const handleOpenDeleteExpenseDialog = (expense) => {
    setSelectedExpense(expense);
    setOpenDeleteExpenseDialog(true);
  };

  const handleCloseDeleteExpenseDialog = () => {
    setSelectedExpense(null);
    setOpenDeleteExpenseDialog(false);
  };

  const handleConfirmDelete = () => {
    if (selectedExpense) {
      handleDeleteExpense(selectedExpense.id); // Backend ile bağlantı kuran fonksiyon
    }
    handleCloseDeleteExpenseDialog();
  };

  const handleDeleteExpense = async (expenseId) => {
    try {
      await api.delete(`/api/expenses/${expenseId}`);
      // Gider listesini güncelle
      setExpenses((prevExpenses) => prevExpenses.filter((expense) => expense.id !== expenseId));
    } catch (error) {
      console.error("Error deleting expense:", error);
    }
  };

  const handleOpenDeleteRiskDialog = (risk) => {
    setSelectedRisk(risk);
    setOpenDeleteRiskDialog(true);
  };

  const handleCloseDeleteRiskDialog = () => {
    setSelectedRisk(null);
    setOpenDeleteRiskDialog(false);
  };

  const handleConfirmDeleteRisk = () => {
    if (selectedRisk) {
      handleDeleteRisk(selectedRisk.id); // Backend ile bağlantı kuran fonksiyon
    }
    handleCloseDeleteRiskDialog();
  };

  const handleDeleteRisk = async (riskId) => {
    try {
      await api.delete(`/api/risks/${riskId}`);
      // Gider listesini güncelle
      setRisks((prevRisks) => prevRisks.filter((risk) => risk.id !== riskId));
    } catch (error) {
      console.error("Error deleting expense:", error);
    }
  };

  const handleAddRisk = async () => {
    try {
      await api.post(
        `/api/risks`,
        {
          project_id: projectId, // Proje ID'si
          name: newRiskName, // Risk adı
          description: newRiskDescription, // Risk açıklaması
          likelihood: newRiskLikelihood, // Olasılık (Low, Medium, High)
          impact: newRiskImpact, // Etki (Low, Medium, High)
          risk_level: calculateRiskLevel(newRiskLikelihood, newRiskImpact), // Olasılık x Etki
          category_id: selectedRiskCategory, // Kategori ID'si
          task_id: selectedRiskTask, // Opsiyonel görev ID'si
          created_by: currentUserId, // Risk oluşturucu ID'si
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        }
      );

      // Formu temizle
      setNewRiskName('');
      setNewRiskDescription('');
      setNewRiskLikelihood('');
      setNewRiskImpact('');
      setSelectedRiskCategory('');
      setSelectedRiskTask('');

      // Risk listesini yenile
      fetchRisks(); // Yeni riski listeye eklemek için tekrar yükle
    } catch (error) {
      console.error('Error adding risk:', error);
    }
  };



  const handleAddRiskCategory = async () => {
    if (!newRiskCategoryName.trim()) {
      alert(t("category_name_empty"));
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await api.post(
        '/api/riskCategories',
        {
          name: newRiskCategoryName,
          project_id: projectId, // Proje ID'si backend ile uyumlu şekilde gönderiliyor
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Yeni kategoriyi mevcut kategoriler listesine ekle
      setRiskCategories((prevRiskCategories) => [...prevRiskCategories, response.data]);

      // Kullanıcıya bilgi ver ve seçili kategoriyi yeni kategori olarak ayarla
      alert(t("category_added"));
      setSelectedRiskCategory(response.data.id);
      setAddingNewRiskCategory(false);
      // TextField temizle
      setNewRiskCategoryName('');
    } catch (error) {
      console.error('Error adding category:', error.message || error);
      alert(t("add_category_failed"));
    }
  };

  const calculateRiskLevel = (likelihood, impact) => {
    const levels = { Low: 1, Medium: 2, High: 3 };
    return levels[likelihood] * levels[impact];
  };

  const handleEditRiskClick = (risk) => {
    setEditingRiskId(risk.id);
    setUpdatedRisk({ ...risk }); // Mevcut risk verilerini düzenleme alanına taşı
  };

  const handleSaveRiskClick = async () => {
    try {
      await api.put(`/api/risks/${editingRiskId}`, updatedRisk, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setEditingRiskId(null);
      fetchRisks(); // Listeyi güncelle
    } catch (error) {
      console.error('Error updating risk:', error);
    }
  };

  const handleCancelRiskClick = () => {
    setEditingRiskId(null); // Düzenleme modunu kapat
    setUpdatedRisk({});
  };

  const handleRiskChange = (field, value) => {
    setUpdatedRisk((prev) => ({ ...prev, [field]: value }));
  };


  // Risk seviyelerine göre filtreleme
  const lowRiskCount = risks.filter((risk) => risk.likelihood === 'Low').length;
  const mediumRiskCount = risks.filter((risk) => risk.likelihood === 'Medium').length;
  const highRiskCount = risks.filter((risk) => risk.likelihood === 'High').length;

  // Toplam risk sayısı
  const totalRisks = risks.length;

  // Chart.js için veriler
  const riskdata = {
    labels: ['Low', 'Medium', 'High'],
    datasets: [
      {
        label: 'Risk Distribution',
        data: [lowRiskCount, mediumRiskCount, highRiskCount],
        backgroundColor: ['#4caf50', '#ffc107', '#f44336'], // Renkler
        borderColor: ['#4caf50', '#ffc107', '#f44336'], // Çerçeve renkleri
        borderWidth: 1,
      },
    ],
  };

  const riskColors = {
    high: "#1E3A8A", // koyu mavi
    medium: "#3B82F6", // Sky Blue
    low: "#93C5FD", // Çok açık mavi"
  };





  if (!project || !stats) {
    return <div>Loading...</div>;
  }

  return (
    <Container maxWidth="xl" className="container">

      <Box className='box-half' >
        <Typography variant="h6" className="header">
          <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <DashboardIcon style={{ marginRight: '8px', color: '#2d3748', fontSize: '1.5rem' }} />
            <span className="header-text">
              {t('project.details')}: {project.name}
            </span>
          </div>
          {isManager && (
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setInviteModalOpen(true)}
            >
              {t('project.inviteMember')}
            </Button>
          )}
        </Typography>

        <Box>
          <Grid container spacing={1} style={{
            padding: 15,
          }}>
            <Grid item xs={12} sm={6} md={4}>
              <Card className="card-total-tasks" onClick={() => scrollToTasks("all")} style={{ cursor: "pointer" }}>
                <CardContent className="card-content">
                  <div className="card-text">
                    <Typography className="card-title">
                      {t('dashboardx.totalTasks')}
                    </Typography>
                    <Typography className="card-stat">{stats.totalTasks || 0}</Typography>
                  </div>
                  <div className="card-icon">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/task.png`}
                      alt={t('dashboardx.totalTasksIcon')}
                      style={{
                        width: '64px',
                        height: '64px',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Card className="card-completed-tasks" onClick={() => scrollToTasks("completed")} style={{ cursor: "pointer" }}>
                <CardContent className="card-content">
                  <div className="card-text">
                    <Typography className="card-title">
                      {t('dashboardx.completedTasks')}
                    </Typography>
                    <Typography className="card-stat">{stats.completedTasks || 0}</Typography>
                  </div>
                  <div className="card-icon">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/checklist.png`}
                      alt={t('dashboardx.completedTasksIcon')}
                      style={{
                        width: '64px',
                        height: '64px',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Card className="card-overdue-tasks" onClick={() => scrollToTasks("overdue")} style={{ cursor: "pointer" }}>
                <CardContent className="card-content">
                  <div className="card-text">
                    <Typography className="card-title">
                      {t('dashboardx.overdueTasks')}
                    </Typography>
                    <Typography className="card-stat">{stats.overdueTasks || 0}</Typography>
                  </div>
                  <div className="card-icon">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/overdue.png`}
                      alt={t('dashboardx.overdueTasksIcon')}
                      style={{
                        width: '64px',
                        height: '64px',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Link to={`/projectmembers/${projectId}`} style={{ textDecoration: "none" }}>
                <Card className="card-project-members">
                  <CardContent className="card-content">
                    <div className="card-text">
                      <Typography className="card-title">
                        {t('dashboardx.projectMembers')}
                      </Typography>
                      <Typography className="card-stat">{stats.memberCount}</Typography>
                    </div>
                    <div className="card-icon">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/group.png`}
                        alt={t('dashboardx.projectMembersIcon')}
                        style={{
                          width: '64px',
                          height: '64px',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Link to={`/projectteams/${projectId}`} style={{ textDecoration: "none" }}>
                <Card className="card-teams">
                  <CardContent className="card-content">
                    <div className="card-text">
                      <Typography className="card-title">
                        {t('dashboardx.projectTeams')}
                      </Typography>
                      <Typography className="card-stat">{stats.teamCount}</Typography>
                    </div>
                    <div className="card-icon">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/people.png`}
                        alt={t('dashboardx.projectTeamsIcon')}
                        style={{
                          width: '64px',
                          height: '64px',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Card className="card-task-progress">
                <CardContent className="card-content">
                  <div className="card-text">
                    <Typography className="card-title">
                      {t('dashboardx.taskProgress')}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={progressPercentage}
                      style={{
                        backgroundColor: "#e0e0e0",
                        borderRadius: "4px",
                        height: "8px",
                      }}
                      classes={{
                        bar: "progress-bar",
                      }}
                    />
                    <Typography variant="body2">
                      {t('dashboardx.taskProgressPercentage', { percentage: Math.round(progressPercentage) })}
                    </Typography>
                  </div>
                  <div className="card-icon">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/images/growth.png`}
                      alt={t('dashboardx.growthIcon')}
                      style={{
                        width: '64px',
                        height: '64px',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </CardContent>
              </Card>
            </Grid>


            {/* Expenses Card */}
            <Grid item xs={12} sm={3} md={6}>
              <Card className="card-expenses">
                <CardContent style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1, gap: '10px' }}>
                    {isEditingBudget ? (
                      <>
                        <TextField
                          label={t('budget.setBudget')}
                          fullWidth
                          value={budgetLimit}
                          onChange={(e) => setBudgetLimit(e.target.value)}
                          margin="normal"
                        />
                        <Select
                          value={currency || 'USD'}
                          onChange={(e) => setCurrency(e.target.value)}
                          style={{ flex: 1 }}
                          displayEmpty
                        >
                          <MenuItem value="USD">USD ($)</MenuItem>
                          <MenuItem value="EUR">EUR (€)</MenuItem>
                          <MenuItem value="TRY">TRY (₺)</MenuItem>
                        </Select>
                        <Box style={{ display: 'flex', gap: '10px' }}>
                          <Button variant="outlined" color="primary" onClick={handleSaveBudget}>
                            {t('budget.save')}
                          </Button>
                          <Button variant="outlined" color="secondary" onClick={() => setIsEditingBudget(false)}>
                            {t('budget.cancel')}
                          </Button>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Typography className="card-title" style={{ cursor: 'pointer' }} onClick={() => setExpensesModalOpen(true)}>
                          {t('budget.costManagement')}
                        </Typography>
                        <Typography className="card-title2" onClick={() => setIsEditingBudget(true)} style={{ cursor: 'pointer' }}>
                          {t('budget.budgetLimit')}: {project?.currency} {project?.total_budget || t('budget.notSet')}
                        </Typography>
                        <Typography className="card-title2">
                          {t('budget.totalExpenses')}: {project?.currency} {expenses.reduce((sum, expense) => sum + Number(expense.amount), 0).toFixed(2)}
                        </Typography>
                        <Typography className="card-title2">
                          {t('budget.budgetDifference')}: {project?.currency} {(
                            project?.total_budget - expenses.reduce((sum, expense) => sum + Number(expense.amount), 0)
                          ).toFixed(2)}
                        </Typography>
                        <Box style={{ display: 'flex', gap: '10px' }}>
                          <Button variant="outlined" color="primary" onClick={() => setIsEditingBudget(true)}>
                            {t('budget.updateBudget')}
                          </Button>
                          <Button variant="outlined" color="primary" onClick={() => setExpensesModalOpen(true)}>
                            {t('budget.viewExpenses')}
                          </Button>
                        </Box>
                      </>
                    )}
                  </Box>
                  <Box style={{ flex: 0.5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box style={{ width: '120px', height: '120px' }}>
                      <Doughnut
                        data={{
                          labels: [
                            ...expenseCategories.map((category) => category.name),
                            'Uncategorized',
                          ],
                          datasets: [
                            {
                              data: [
                                ...expenseCategories.map((category) =>
                                  expenses
                                    .filter((expense) => expense.category_id === category.id)
                                    .reduce((sum, expense) => sum + Number(expense.amount), 0)
                                ),
                                expenses
                                  .filter((expense) => !expense.category_id)
                                  .reduce((sum, expense) => sum + Number(expense.amount), 0),
                              ],
                              backgroundColor: [
                                '#1E3A8A', // Koyu mavi
                                '#2563EB', // Orta mavi
                                '#3B82F6', // Açık mavi
                                '#60A5FA', // Daha açık mavi
                                '#93C5FD', // Çok açık mavi
                                '#BFDBFE', // Pastel mavi
                                '#DBEAFE', // Çok açık pastel mavi
                              ],
                              hoverOffset: 4,
                              cutout: '80%', // Simit inceltme
                            },
                          ],
                        }}
                        options={{
                          maintainAspectRatio: false,
                          responsive: true,
                          plugins: {
                            legend: {
                              display: false, // Legend'ı gizle
                            },
                          },
                          
                        }}
                      />

                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Card className="card-risk-management">
                <CardContent style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1, gap: '10px' }}>
                    <Typography className="card-title" style={{ cursor: 'pointer' }} onClick={() => setRisksModalOpen(true)}>
                      {t('risk.riskManagement')}
                    </Typography>
                    <Typography className="card-title2" style={{ color: riskColors.high }}>
                      {t('risk.highRiskLevel')} (<strong>{risks.filter(risk => risk.status !== 'Closed' && calculateRiskLevel(risk.likelihood, risk.impact) >= 6).length}</strong>)
                    </Typography>
                    <Typography className="card-title2" style={{ color: riskColors.medium }}>
                      {t('risk.mediumRiskLevel')} (<strong>{risks.filter(risk => risk.status !== 'Closed' && calculateRiskLevel(risk.likelihood, risk.impact) < 6 && calculateRiskLevel(risk.likelihood, risk.impact) >= 3).length}</strong>)
                    </Typography>
                    <Typography className="card-title2" style={{ color: riskColors.low }}>
                      {t('risk.lowRiskLevel')} (<strong>{risks.filter(risk => risk.status !== 'Closed' && calculateRiskLevel(risk.likelihood, risk.impact) < 3).length}</strong>)
                    </Typography>
                    <Button variant="outlined" color="primary" onClick={() => setRisksModalOpen(true)}>
                      {t('risk.viewRisks')}
                    </Button>
                  </Box>
                  {/* Sağ Bölüm: Pie Chart */}
                  <Box style={{ flex: 0.5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box style={{ width: '120px', height: '120px' }}>
                      <Doughnut
                        data={{
                          labels: ['Low Risk Level', 'Medium Risk Level', 'High Risk Level'],
                          datasets: [
                            {
                              data: [
                                risks.filter(
                                  (risk) =>
                                    risk.status !== 'Closed' && calculateRiskLevel(risk.likelihood, risk.impact) < 3
                                ).length,
                                risks.filter(
                                  (risk) =>
                                    risk.status !== 'Closed' &&
                                    calculateRiskLevel(risk.likelihood, risk.impact) < 6 &&
                                    calculateRiskLevel(risk.likelihood, risk.impact) >= 3
                                ).length,
                                risks.filter(
                                  (risk) =>
                                    risk.status !== 'Closed' && calculateRiskLevel(risk.likelihood, risk.impact) >= 6
                                ).length,
                              ],
                              backgroundColor: [riskColors.low, riskColors.medium, riskColors.high],
                              hoverOffset: 4,
                              cutout: '80%', // İç kısmı açmak için
                            },
                          ],
                        }}
                        options={{
                          maintainAspectRatio: false,
                          responsive: true,
                          plugins: {
                            legend: {
                              display: false,
                              position: 'right',
                            },
                            

                          },
                        }}
                      />


                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>


          </Grid>
        </Box>
      </Box>


      <Box className='box-half'>
        <Typography variant="h6" className="header">
          <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <AssignmentIcon style={{ marginRight: '8px', color: '#2d3748', fontSize: '1.5rem' }} />
            <span className="header-text">{t('tasksx.title')}</span>
          </div>
          {hasPermission && (
            <Button
              variant="outlined"
              onClick={() => setTaskModalOpen(true)}
            >
              {t('tasksx.addNewTask')}
            </Button>
          )}
        </Typography>


        {userRoleId === 2 || userRoleId === 3 ? (
          isMobile ? (
            <Select
              value={activeTab}
              onChange={handleSelectChange}
              variant="outlined"
              fullWidth
              style={{ marginBottom: '16px' }}
            >
              <MenuItem value="personal">{t('tasksx.myTasks')}</MenuItem>
              <MenuItem value="team">{t('tasksx.relatedTeamTasks')}</MenuItem>
              <MenuItem value="other">{t('tasksx.otherTasks')}</MenuItem>
              <MenuItem value="all">{t('tasksx.allTasks')}</MenuItem>
              <MenuItem value="completed">{t('tasksx.completedTasks')}</MenuItem>
              <MenuItem value="overdue">{t('tasksx.overdueTasks')}</MenuItem>
            </Select>
          ) : (
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab label={t('tasksx.myTasks')} value="personal" />
              <Tab label={t('tasksx.relatedTeamTasks')} value="team" />
              <Tab label={t('tasksx.otherTasks')} value="other" />
              <Tab label={t('tasksx.allTasks')} value="all" />
              <Tab label={t('tasksx.completedTasks')} value="completed" />
              <Tab label={t('tasksx.overdueTasks')} value="overdue" />
            </Tabs>
          )
        ) : userRoleId === 1 ? (
          isMobile ? (
            <Select
              value={activeTab}
              onChange={handleSelectChange}
              variant="outlined"
              fullWidth
              style={{ marginBottom: '16px' }}
            >
              <MenuItem value="all">{t('tasksx.allTasks')}</MenuItem>
              <MenuItem value="personal">{t('tasksx.myTasks')}</MenuItem>
              <MenuItem value="pmuser">{t('tasksx.userAssignedTasks')}</MenuItem>
              <MenuItem value="pmteam">{t('tasksx.teamAssignedTasks')}</MenuItem>
              <MenuItem value="completed">{t('tasksx.completedTasks')}</MenuItem>
              <MenuItem value="overdue">{t('tasksx.overdueTasks')}</MenuItem>
            </Select>
          ) : (
            <Tabs value={activeTab} onChange={handleTabChange}>
              <Tab label={t('tasksx.allTasks')} value="all" />
              <Tab label={t('tasksx.myTasks')} value="personal" />
              <Tab label={t('tasksx.userAssignedTasks')} value="pmuser" />
              <Tab label={t('tasksx.teamAssignedTasks')} value="pmteam" />
              <Tab label={t('tasksx.completedTasks')} value="completed" />
              <Tab label={t('tasksx.overdueTasks')} value="overdue" />
            </Tabs>
          )
        ) : null}



        {/* Personal Tasks Tab Content */}
        {activeTab === 'personal' && (
          <Box>
            <table className="task-table">
              {/* Tablo Başlığı */}
              <thead>
                <tr className="table-header">
                  <th className="header-item">{t('tasksx.actions')}</th>
                  <th className="header-item">{t('tasksx.title')}</th>
                  <th className="header-item">{t('tasksx.dueDate')}</th>
                  <th className="header-item">{t('tasksx.assignedTo')}</th>
                  <th className="header-item">{t('tasksx.assignedTeam')}</th>
                  <th className="header-item">{t('tasksx.assignedBy')}</th>
                  <th className="header-item">{t('tasksx.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {personalTasks.map((task) => {
                  const isExpanded = expandedSubtasks[task.id]; // Alt görevlerin açılıp açılmadığını kontrol et
                  const assignedTo = task.assignedUser ? task.assignedUser.name : '-';
                  const assignedBy = task.createdByUser ? task.createdByUser.name : '-';
                  const assignedTeam = task.assignedTeam ? task.assignedTeam.name : '-';

                  return (
                    <React.Fragment key={task.id}>
                      <tr className={`table-row ${isExpanded ? 'expanded-task-row' : ''}`}>
                        {/* Actions Düğmeleri */}
                        <td>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleSubtaskAccordionToggle(task.id)}
                          >
                            <AccountTreeIcon />
                          </IconButton>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleOpenTaskDetailsModal(task)}
                          >
                            <MenuIcon />
                          </IconButton>
                        </td>
                        <td>{task.title}</td>
                        <td>{new Date(task.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                        <td>{assignedTo}</td>
                        <td>{assignedTeam}</td>
                        <td>{assignedBy}</td>
                        <td>
                          {(isManager || task.created_by_user_id === currentUserId) && (
                            <IconButton onClick={() => handleOpenDeleteModal('task', task)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>

                      {/* Alt Görevler */}
                      {expandedSubtasks[task.id] && (
                        <>
                          {/* Subtasks List Header */}
                          <tr className="subtask-header-row">
                            <td colSpan="6">
                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6">{t('tasksx.subtasksList')}</Typography>
                                {isPermittedToAddSubtask && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCreateSubtaskClick(task)}
                                  >
                                    {t('tasksx.addNewSubtask')}
                                  </Button>
                                )}
                              </Box>
                            </td>
                          </tr>

                          {/* Subtasks Header */}
                          <tr className="subtask-header-row">
                            <td></td>
                            <td className="header-item">{t('tasksx.title')}</td>
                            <td className="header-item">{t('tasksx.dueDate')}</td>
                            <td className="header-item">{t('tasksx.assignedTo')}</td>
                            <td className="header-item">{t('tasksx.assignedBy')}</td>
                            <td className="header-item">{t('tasksx.delete')}</td>
                          </tr>

                          {/* Subtasks Rows */}
                          {task.subtasks && task.subtasks.length > 0 ? (
                            task.subtasks.map((subtask) => {
                              const subtaskAssignedTo = subtask.AssignedUser ? subtask.AssignedUser.name : '-';
                              const subtaskAssignedBy = subtask.AssignedByUser ? subtask.AssignedByUser.name : '-';

                              return (
                                <tr key={subtask.id} className="subtask-row">
                                  <td>
                                    <IconButton
                                      className="task-buttons"
                                      onClick={() => handleOpenSubtaskDetailsModal(subtask)}
                                    >
                                      <MenuIcon />
                                    </IconButton>
                                  </td>
                                  <td>{subtask.title}</td>
                                  <td>{new Date(subtask.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                  <td>{subtaskAssignedTo}</td>
                                  <td>{subtaskAssignedBy}</td>
                                  <td>
                                    <IconButton onClick={() => handleOpenDeleteModal('subtask', subtask)}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="no-subtasks-row">
                              <td colSpan="6">{t('tasksx.noSubtasksAvailable')}</td>
                            </tr>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
            {/* Personal Tasks Pagination */}
            <Pagination
              totalItems={totalPersonalTasks}
              itemsPerPage={itemsPerPage}
              currentPage={currentPages.personal}
              onPageChange={(page) => handlePageChange('personal', page)}
            />
          </Box>
        )}

        {/* Team Tasks Tab Content */}
        {activeTab === 'team' && (
          <Box>
            <table className="task-table">
              {/* Tablo Başlığı */}
              <thead>
                <tr className="table-header">
                  <th className="header-item">{t('tasksx.actions')}</th>
                  <th className="header-item">{t('tasksx.title')}</th>
                  <th className="header-item">{t('tasksx.dueDate')}</th>
                  <th className="header-item">{t('tasksx.assignedTo')}</th>
                  <th className="header-item">{t('tasksx.assignedTeam')}</th>
                  <th className="header-item">{t('tasksx.assignedBy')}</th>
                  <th className="header-item">{t('tasksx.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {teamTasks.map((task) => {
                  const isExpanded = expandedSubtasks[task.id]; // Alt görevlerin açılıp açılmadığını kontrol et
                  const assignedTo = task.assignedUser ? task.assignedUser.name : '-';
                  const assignedTeam = task.assignedTeam ? task.assignedTeam.name : '-';
                  const assignedBy = task.createdByUser ? task.createdByUser.name : '-';

                  return (
                    <React.Fragment key={task.id}>
                      <tr className={`table-row ${isExpanded ? 'expanded-task-row' : ''}`}>
                        {/* Actions Düğmeleri */}
                        <td>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleSubtaskAccordionToggle(task.id)}
                          >
                            <AccountTreeIcon />
                          </IconButton>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleOpenTaskDetailsModal(task)}
                          >
                            <MenuIcon />
                          </IconButton>
                        </td>
                        <td>{task.title}</td>
                        <td>{new Date(task.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                        <td>{assignedTo}</td>
                        <td>{assignedTeam}</td>
                        <td>{assignedBy}</td>
                        <td>
                          {(isManager || task.created_by_user_id === currentUserId) && (
                            <IconButton onClick={() => handleOpenDeleteModal('task', task)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>

                      {/* Alt Görevler */}
                      {expandedSubtasks[task.id] && (
                        <>
                          {/* Subtasks List Header */}
                          <tr className="subtask-header-row">
                            <td colSpan="6">
                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6">{t('tasksx.subtasksList')}</Typography>
                                {isPermittedToAddSubtask && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCreateSubtaskClick(task)}
                                  >
                                    {t('tasksx.addNewSubtask')}
                                  </Button>
                                )}
                              </Box>
                            </td>
                          </tr>

                          {/* Subtasks Header */}
                          <tr className="subtask-header-row">
                            <td></td>
                            <td className="header-item">{t('tasksx.title')}</td>
                            <td className="header-item">{t('tasksx.dueDate')}</td>
                            <td className="header-item">{t('tasksx.assignedTo')}</td>
                            <td className="header-item">{t('tasksx.assignedBy')}</td>
                            <td className="header-item">{t('tasksx.delete')}</td>
                          </tr>

                          {/* Subtasks Rows */}
                          {task.subtasks && task.subtasks.length > 0 ? (
                            task.subtasks.map((subtask) => {
                              const subtaskAssignedTo = subtask.AssignedUser ? subtask.AssignedUser.name : '-';
                              const subtaskAssignedBy = subtask.AssignedByUser ? subtask.AssignedByUser.name : '-';

                              return (
                                <tr key={subtask.id} className="subtask-row">
                                  <td>
                                    <IconButton
                                      className="task-buttons"
                                      onClick={() => handleOpenSubtaskDetailsModal(subtask)}
                                    >
                                      <MenuIcon />
                                    </IconButton>
                                  </td>
                                  <td>{subtask.title}</td>
                                  <td>{new Date(subtask.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                  <td>{subtaskAssignedTo}</td>
                                  <td>{subtaskAssignedBy}</td>
                                  <td>
                                    <IconButton onClick={() => handleOpenDeleteModal('subtask', subtask)}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="no-subtasks-row">
                              <td colSpan="6">{t('tasksx.noSubtasksAvailable')}</td>
                            </tr>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>

            {/* Team Tasks Pagination */}
            <Pagination
              totalItems={totalTeamTasks}
              itemsPerPage={itemsPerPage}
              currentPage={currentPages.team}
              onPageChange={(page) => handlePageChange('team', page)}
            />
          </Box>
        )}

        {/* Other Tasks Tab Content */}
        {activeTab === 'other' && (
          <Box>
            <table className="task-table">
              {/* Tablo Başlığı */}
              <thead>
                <tr className="table-header">
                  <th className="header-item">{t('tasksx.actions')}</th>
                  <th className="header-item">{t('tasksx.title')}</th>
                  <th className="header-item">{t('tasksx.dueDate')}</th>
                  <th className="header-item">{t('tasksx.assignedTo')}</th>
                  <th className="header-item">{t('tasksx.assignedTeam')}</th>
                  <th className="header-item">{t('tasksx.assignedBy')}</th>
                  <th className="header-item">{t('tasksx.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {otherTasks.map((task) => {
                  const isExpanded = expandedSubtasks[task.id]; // Alt görevlerin açılıp açılmadığını kontrol et
                  const assignedTo = task.assignedUser ? task.assignedUser.name : '-';
                  const assignedBy = task.createdByUser ? task.createdByUser.name : '-';
                  const assignedTeam = task.assignedTeam ? task.assignedTeam.name : '-';

                  return (
                    <React.Fragment key={task.id}>
                      <tr className={`table-row ${isExpanded ? 'expanded-task-row' : ''}`}>
                        {/* Actions Düğmeleri */}
                        <td>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleSubtaskAccordionToggle(task.id)}
                          >
                            <AccountTreeIcon />
                          </IconButton>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleOpenTaskDetailsModal(task)}
                          >
                            <MenuIcon />
                          </IconButton>
                        </td>
                        <td>{task.title}</td>
                        <td>{new Date(task.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                        <td>{assignedTo}</td>
                        <td>{assignedTeam}</td>
                        <td>{assignedBy}</td>
                        <td>
                          {(isManager || task.created_by_user_id === currentUserId) && (
                            <IconButton onClick={() => handleOpenDeleteModal('task', task)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>

                      {/* Alt Görevler */}
                      {expandedSubtasks[task.id] && (
                        <>
                          {/* Subtasks List Header */}
                          <tr className="subtask-header-row">
                            <td colSpan="6">
                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6">{t('tasksx.subtasksList')}</Typography>
                                {isPermittedToAddSubtask && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCreateSubtaskClick(task)}
                                  >
                                    {t('tasksx.addNewSubtask')}
                                  </Button>
                                )}
                              </Box>
                            </td>
                          </tr>

                          {/* Subtasks Header */}
                          <tr className="subtask-header-row">
                            <td></td>
                            <td className="header-item">{t('tasksx.title')}</td>
                            <td className="header-item">{t('tasksx.dueDate')}</td>
                            <td className="header-item">{t('tasksx.assignedTo')}</td>
                            <td className="header-item">{t('tasksx.assignedBy')}</td>
                            <td className="header-item">{t('tasksx.delete')}</td>
                          </tr>

                          {/* Subtasks Rows */}
                          {task.subtasks && task.subtasks.length > 0 ? (
                            task.subtasks.map((subtask) => {
                              const subtaskAssignedTo = subtask.AssignedUser ? subtask.AssignedUser.name : '-';
                              const subtaskAssignedBy = subtask.AssignedByUser ? subtask.AssignedByUser.name : '-';

                              return (
                                <tr key={subtask.id} className="subtask-row">
                                  <td>
                                    <IconButton
                                      className="task-buttons"
                                      onClick={() => handleOpenSubtaskDetailsModal(subtask)}
                                    >
                                      <MenuIcon />
                                    </IconButton>
                                  </td>
                                  <td>{subtask.title}</td>
                                  <td>{new Date(subtask.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                  <td>{subtaskAssignedTo}</td>
                                  <td>{subtaskAssignedBy}</td>
                                  <td>
                                    <IconButton onClick={() => handleOpenDeleteModal('subtask', subtask)}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="no-subtasks-row">
                              <td colSpan="6">{t('tasksx.noSubtasksAvailable')}</td>
                            </tr>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
            {/* Other Tasks Pagination */}
            <Pagination
              totalItems={totalOtherTasks}
              itemsPerPage={itemsPerPage}
              currentPage={currentPages.other}
              onPageChange={(page) => handlePageChange('other', page)}
            />

          </Box>
        )}
        {/* PMANAGER Users Tab Content */}
        {activeTab === 'pmuser' && (
          <Box>
            <table className="task-table">
              {/* Tablo Başlığı */}
              <thead>
                <tr className="table-header">
                  <th className="header-item">{t('tasksx.actions')}</th>
                  <th className="header-item">{t('tasksx.title')}</th>
                  <th className="header-item">{t('tasksx.dueDate')}</th>
                  <th className="header-item">{t('tasksx.assignedTo')}</th>
                  <th className="header-item">{t('tasksx.assignedTeam')}</th>
                  <th className="header-item">{t('tasksx.assignedBy')}</th>
                  <th className="header-item">{t('tasksx.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {pmUserTasks.map((task) => {
                  const isExpanded = expandedSubtasks[task.id];
                  const assignedTo = task.assignedUser ? task.assignedUser.name : '-';
                  const assignedBy = task.createdByUser ? task.createdByUser.name : '-';
                  const assignedTeam = task.assignedTeam ? task.assignedTeam.name : '-';

                  return (
                    <React.Fragment key={task.id}>
                      <tr className={`table-row ${isExpanded ? 'expanded-task-row' : ''}`}>
                        <td>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleSubtaskAccordionToggle(task.id)}
                          >
                            <AccountTreeIcon />
                          </IconButton>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleOpenTaskDetailsModal(task)}
                          >
                            <MenuIcon />
                          </IconButton>
                        </td>
                        <td>{task.title}</td>
                        <td>{new Date(task.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                        <td>{assignedTo}</td>
                        <td>{assignedTeam}</td>
                        <td>{assignedBy}</td>
                        <td>
                          {(isManager || task.created_by_user_id === currentUserId) && (
                            <IconButton onClick={() => handleOpenDeleteModal('task', task)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>

                      {expandedSubtasks[task.id] && (
                        <>
                          <tr className="subtask-header-row">
                            <td colSpan="6">
                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6">{t('tasksx.subtasksList')}</Typography>
                                {isPermittedToAddSubtask && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCreateSubtaskClick(task)}
                                  >
                                    {t('tasksx.addNewSubtask')}
                                  </Button>
                                )}
                              </Box>
                            </td>
                          </tr>

                          <tr className="subtask-header-row">
                            <td></td>
                            <td className="header-item">{t('tasksx.title')}</td>
                            <td className="header-item">{t('tasksx.dueDate')}</td>
                            <td className="header-item">{t('tasksx.assignedTo')}</td>
                            <td className="header-item">{t('tasksx.assignedBy')}</td>
                            <td className="header-item">{t('tasksx.delete')}</td>
                          </tr>

                          {task.subtasks && task.subtasks.length > 0 ? (
                            task.subtasks.map((subtask) => {
                              const subtaskAssignedTo = subtask.AssignedUser ? subtask.AssignedUser.name : '-';
                              const subtaskAssignedBy = subtask.AssignedByUser ? subtask.AssignedByUser.name : '-';

                              return (
                                <tr key={subtask.id} className="subtask-row">
                                  <td>
                                    <IconButton
                                      className="task-buttons"
                                      onClick={() => handleOpenSubtaskDetailsModal(subtask)}
                                    >
                                      <MenuIcon />
                                    </IconButton>
                                  </td>
                                  <td>{subtask.title}</td>
                                  <td>{new Date(subtask.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                  <td>{subtaskAssignedTo}</td>
                                  <td>{subtaskAssignedBy}</td>
                                  <td>
                                    <IconButton onClick={() => handleOpenDeleteModal('subtask', subtask)}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="no-subtasks-row">
                              <td colSpan="6">{t('tasksx.noSubtasksAvailable')}</td>
                            </tr>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
            {/* Other Tasks Pagination */}
            <Pagination
              totalItems={totalPManagerUserTasks}
              itemsPerPage={itemsPerPage}
              currentPage={currentPages.pmuser}
              onPageChange={(page) => handlePageChange('pmuser', page)}
            />
          </Box>
        )}

        {/* PM TEAM Tasks Tab Content */}
        {activeTab === 'pmteam' && (
          <Box>
            <table className="task-table">
              {/* Tablo Başlığı */}
              <thead>
                <tr className="table-header">
                  <th className="header-item">{t('tasksx.actions')}</th>
                  <th className="header-item">{t('tasksx.title')}</th>
                  <th className="header-item">{t('tasksx.dueDate')}</th>
                  <th className="header-item">{t('tasksx.assignedTo')}</th>
                  <th className="header-item">{t('tasksx.assignedTeam')}</th>
                  <th className="header-item">{t('tasksx.assignedBy')}</th>
                  <th className="header-item">{t('tasksx.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {pmTeamTasks.map((task) => {
                  const isExpanded = expandedSubtasks[task.id];
                  const assignedTo = task.assignedUser ? task.assignedUser.name : '-';
                  const assignedBy = task.createdByUser ? task.createdByUser.name : '-';
                  const assignedTeam = task.assignedTeam ? task.assignedTeam.name : '-';

                  return (
                    <React.Fragment key={task.id}>
                      <tr className={`table-row ${isExpanded ? 'expanded-task-row' : ''}`}>
                        <td>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleSubtaskAccordionToggle(task.id)}
                          >
                            <AccountTreeIcon />
                          </IconButton>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleOpenTaskDetailsModal(task)}
                          >
                            <MenuIcon />
                          </IconButton>
                        </td>
                        <td>{task.title}</td>
                        <td>{new Date(task.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                        <td>{assignedTo}</td>
                        <td>{assignedTeam}</td>
                        <td>{assignedBy}</td>
                        <td>
                          {(isManager || task.created_by_user_id === currentUserId) && (
                            <IconButton onClick={() => handleOpenDeleteModal('task', task)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>

                      {expandedSubtasks[task.id] && (
                        <>
                          <tr className="subtask-header-row">
                            <td colSpan="6">
                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6">{t('tasksx.subtasksList')}</Typography>
                                {isPermittedToAddSubtask && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCreateSubtaskClick(task)}
                                  >
                                    {t('tasksx.addNewSubtask')}
                                  </Button>
                                )}
                              </Box>
                            </td>
                          </tr>

                          <tr className="subtask-header-row">
                            <td></td>
                            <td className="header-item">{t('tasksx.title')}</td>
                            <td className="header-item">{t('tasksx.dueDate')}</td>
                            <td className="header-item">{t('tasksx.assignedTo')}</td>
                            <td className="header-item">{t('tasksx.assignedBy')}</td>
                            <td className="header-item">{t('tasksx.delete')}</td>
                          </tr>

                          {task.subtasks && task.subtasks.length > 0 ? (
                            task.subtasks.map((subtask) => {
                              const subtaskAssignedTo = subtask.AssignedUser ? subtask.AssignedUser.name : '-';
                              const subtaskAssignedBy = subtask.AssignedByUser ? subtask.AssignedByUser.name : '-';

                              return (
                                <tr key={subtask.id} className="subtask-row">
                                  <td>
                                    <IconButton
                                      className="task-buttons"
                                      onClick={() => handleOpenSubtaskDetailsModal(subtask)}
                                    >
                                      <MenuIcon />
                                    </IconButton>
                                  </td>
                                  <td>{subtask.title}</td>
                                  <td>{new Date(subtask.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                  <td>{subtaskAssignedTo}</td>
                                  <td>{subtaskAssignedBy}</td>
                                  <td>
                                    <IconButton onClick={() => handleOpenDeleteModal('subtask', subtask)}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="no-subtasks-row">
                              <td colSpan="6">{t('tasksx.noSubtasksAvailable')}</td>
                            </tr>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
            {/* Other Tasks Pagination */}
            <Pagination
              totalItems={totalPManagerteamTasks}
              itemsPerPage={itemsPerPage}
              currentPage={currentPages.pmteam}
              onPageChange={(page) => handlePageChange('pmteam', page)}
            />
          </Box>
        )}
        {/* All Tasks Tab Content */}
        {activeTab === 'all' && (
          <Box>
            <table className="task-table">
              {/* Tablo Başlığı */}
              <thead>
                <tr className="table-header">
                  <th className="header-item">{t('tasksx.actions')}</th>
                  <th className="header-item">{t('tasksx.title')}</th>
                  <th className="header-item">{t('tasksx.dueDate')}</th>
                  <th className="header-item">{t('tasksx.assignedTo')}</th>
                  <th className="header-item">{t('tasksx.assignedTeam')}</th>
                  <th className="header-item">{t('tasksx.assignedBy')}</th>
                  <th className="header-item">{t('tasksx.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {allTasks.map((task) => {
                  const isExpanded = expandedSubtasks[task.id]; // Alt görevlerin açılıp açılmadığını kontrol et
                  const assignedTo = task.assignedUser ? task.assignedUser.name : '-';
                  const assignedBy = task.createdByUser ? task.createdByUser.name : '-';
                  const assignedTeam = task.assignedTeam ? task.assignedTeam.name : '-';

                  return (
                    <React.Fragment key={task.id}>
                      <tr className={`table-row ${isExpanded ? 'expanded-task-row' : ''}`}>
                        <td>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleSubtaskAccordionToggle(task.id)}
                          >
                            <AccountTreeIcon />
                          </IconButton>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleOpenTaskDetailsModal(task)}
                          >
                            <MenuIcon />
                          </IconButton>
                        </td>
                        <td>{task.title}</td>
                        <td>{new Date(task.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                        <td>{assignedTo}</td>
                        <td>{assignedTeam}</td>
                        <td>{assignedBy}</td>
                        <td>
                          {(isManager || task.created_by_user_id === currentUserId) && (
                            <IconButton onClick={() => handleOpenDeleteModal('task', task)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>

                      {expandedSubtasks[task.id] && (
                        <>
                          <tr className="subtask-header-row">
                            <td colSpan="6">
                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6">{t('tasksx.subtasksList')}</Typography>
                                {isPermittedToAddSubtask && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCreateSubtaskClick(task)}
                                  >
                                    {t('tasksx.addNewSubtask')}
                                  </Button>
                                )}
                              </Box>
                            </td>
                          </tr>

                          <tr className="subtask-header-row">
                            <td></td>
                            <td className="header-item">{t('tasksx.title')}</td>
                            <td className="header-item">{t('tasksx.dueDate')}</td>
                            <td className="header-item">{t('tasksx.assignedTo')}</td>
                            <td className="header-item">{t('tasksx.assignedBy')}</td>
                            <td className="header-item">{t('tasksx.delete')}</td>
                          </tr>

                          {task.subtasks && task.subtasks.length > 0 ? (
                            task.subtasks.map((subtask) => {
                              const subtaskAssignedTo = subtask.AssignedUser ? subtask.AssignedUser.name : '-';
                              const subtaskAssignedBy = subtask.AssignedByUser ? subtask.AssignedByUser.name : '-';

                              return (
                                <tr key={subtask.id} className="subtask-row">
                                  <td>
                                    <IconButton
                                      className="task-buttons"
                                      onClick={() => handleOpenSubtaskDetailsModal(subtask)}
                                    >
                                      <MenuIcon />
                                    </IconButton>
                                  </td>
                                  <td>{subtask.title}</td>
                                  <td>{new Date(subtask.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                  <td>{subtaskAssignedTo}</td>
                                  <td>{subtaskAssignedBy}</td>
                                  <td>
                                    <IconButton onClick={() => handleOpenDeleteModal('subtask', subtask)}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="no-subtasks-row">
                              <td colSpan="6">{t('tasksx.noSubtasksAvailable')}</td>
                            </tr>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>

            {/* Pagination */}
            <Pagination
              totalItems={totalAllTasks}
              itemsPerPage={itemsPerPage}
              currentPage={currentPages.all}
              onPageChange={(page) => handlePageChange('all', page)}
            />
          </Box>

        )}
        {/* Completed Tasks Tab Content */}
        {activeTab === 'completed' && (

          <Box>
            <table className="task-table">
              {/* Tablo Başlığı */}
              <thead>
                <tr className="table-header">
                  <th className="header-item">{t('tasksx.actions')}</th>
                  <th className="header-item">{t('tasksx.title')}</th>
                  <th className="header-item">{t('tasksx.dueDate')}</th>
                  <th className="header-item">{t('tasksx.assignedTo')}</th>
                  <th className="header-item">{t('tasksx.assignedTeam')}</th>
                  <th className="header-item">{t('tasksx.assignedBy')}</th>
                  <th className="header-item">{t('tasksx.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {completedTasks.map((task) => {
                  const isExpanded = expandedSubtasks[task.id]; // Alt görevlerin açılıp açılmadığını kontrol et
                  const assignedTo = task.assignedUser ? task.assignedUser.name : '-';
                  const assignedBy = task.createdByUser ? task.createdByUser.name : '-';
                  const assignedTeam = task.assignedTeam ? task.assignedTeam.name : '-';

                  return (
                    <React.Fragment key={task.id}>
                      <tr className={`table-row ${isExpanded ? 'expanded-task-row' : ''}`}>
                        <td>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleSubtaskAccordionToggle(task.id)}
                          >
                            <AccountTreeIcon />
                          </IconButton>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleOpenTaskDetailsModal(task)}
                          >
                            <MenuIcon />
                          </IconButton>
                        </td>
                        <td>{task.title}</td>
                        <td>{new Date(task.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                        <td>{assignedTo}</td>
                        <td>{assignedTeam}</td>
                        <td>{assignedBy}</td>
                        <td>
                          {(isManager || task.created_by_user_id === currentUserId) && (
                            <IconButton onClick={() => handleOpenDeleteModal('task', task)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>

                      {expandedSubtasks[task.id] && (
                        <>
                          <tr className="subtask-header-row">
                            <td colSpan="6">
                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6">{t('tasksx.subtasksList')}</Typography>
                                {isPermittedToAddSubtask && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCreateSubtaskClick(task)}
                                  >
                                    {t('tasksx.addNewSubtask')}
                                  </Button>
                                )}
                              </Box>
                            </td>
                          </tr>

                          <tr className="subtask-header-row">
                            <td></td>
                            <td className="header-item">{t('tasksx.title')}</td>
                            <td className="header-item">{t('tasksx.dueDate')}</td>
                            <td className="header-item">{t('tasksx.assignedTo')}</td>
                            <td className="header-item">{t('tasksx.assignedBy')}</td>
                            <td className="header-item">{t('tasksx.delete')}</td>
                          </tr>

                          {task.subtasks && task.subtasks.length > 0 ? (
                            task.subtasks.map((subtask) => {
                              const subtaskAssignedTo = subtask.AssignedUser ? subtask.AssignedUser.name : '-';
                              const subtaskAssignedBy = subtask.AssignedByUser ? subtask.AssignedByUser.name : '-';

                              return (
                                <tr key={subtask.id} className="subtask-row">
                                  <td>
                                    <IconButton
                                      className="task-buttons"
                                      onClick={() => handleOpenSubtaskDetailsModal(subtask)}
                                    >
                                      <MenuIcon />
                                    </IconButton>
                                  </td>
                                  <td>{subtask.title}</td>
                                  <td>{new Date(subtask.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                  <td>{subtaskAssignedTo}</td>
                                  <td>{subtaskAssignedBy}</td>
                                  <td>
                                    <IconButton onClick={() => handleOpenDeleteModal('subtask', subtask)}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="no-subtasks-row">
                              <td colSpan="6">{t('tasksx.noSubtasksAvailable')}</td>
                            </tr>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
            {/* Other Tasks Pagination */}
            <Pagination
              totalItems={totalCompletedTasks}
              itemsPerPage={itemsPerPage}
              currentPage={currentPages.completed}
              onPageChange={(page) => handlePageChange('completed', page)}
            />
          </Box>
        )}
        {/* Overdue Tasks Tab Content */}
        {activeTab === 'overdue' && (
          <Box>
            <table className="task-table">
              {/* Tablo Başlığı */}
              <thead>
                <tr className="table-header">
                  <th className="header-item">{t('tasksx.actions')}</th>
                  <th className="header-item">{t('tasksx.title')}</th>
                  <th className="header-item">{t('tasksx.dueDate')}</th>
                  <th className="header-item">{t('tasksx.assignedTo')}</th>
                  <th className="header-item">{t('tasksx.assignedTeam')}</th>
                  <th className="header-item">{t('tasksx.assignedBy')}</th>
                  <th className="header-item">{t('tasksx.delete')}</th>
                </tr>
              </thead>
              <tbody>
                {overdueTasks.map((task) => {
                  const isExpanded = expandedSubtasks[task.id]; // Alt görevlerin açılıp açılmadığını kontrol et
                  const assignedTo = task.assignedUser ? task.assignedUser.name : '-';
                  const assignedBy = task.createdByUser ? task.createdByUser.name : '-';
                  const assignedTeam = task.assignedTeam ? task.assignedTeam.name : '-';

                  return (
                    <React.Fragment key={task.id}>
                      <tr className={`table-row ${isExpanded ? 'expanded-task-row' : ''}`}>
                        <td>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleSubtaskAccordionToggle(task.id)}
                          >
                            <AccountTreeIcon />
                          </IconButton>
                          <IconButton
                            className="task-buttons"
                            onClick={() => handleOpenTaskDetailsModal(task)}
                          >
                            <MenuIcon />
                          </IconButton>
                        </td>
                        <td>{task.title}</td>
                        <td>{new Date(task.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                        <td>{assignedTo}</td>
                        <td>{assignedTeam}</td>
                        <td>{assignedBy}</td>
                        <td>
                          {(isManager || task.created_by_user_id === currentUserId) && (
                            <IconButton onClick={() => handleOpenDeleteModal('task', task)}>
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>

                      {expandedSubtasks[task.id] && (
                        <>
                          <tr className="subtask-header-row">
                            <td colSpan="6">
                              <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography variant="h6">{t('tasksx.subtasksList')}</Typography>
                                {isPermittedToAddSubtask && (
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleCreateSubtaskClick(task)}
                                  >
                                    {t('tasksx.addNewSubtask')}
                                  </Button>
                                )}
                              </Box>
                            </td>
                          </tr>

                          <tr className="subtask-header-row">
                            <td></td>
                            <td className="header-item">{t('tasksx.title')}</td>
                            <td className="header-item">{t('tasksx.dueDate')}</td>
                            <td className="header-item">{t('tasksx.assignedTo')}</td>
                            <td className="header-item">{t('tasksx.assignedBy')}</td>
                            <td className="header-item">{t('tasksx.delete')}</td>
                          </tr>

                          {task.subtasks && task.subtasks.length > 0 ? (
                            task.subtasks.map((subtask) => {
                              const subtaskAssignedTo = subtask.AssignedUser ? subtask.AssignedUser.name : '-';
                              const subtaskAssignedBy = subtask.AssignedByUser ? subtask.AssignedByUser.name : '-';

                              return (
                                <tr key={subtask.id} className="subtask-row">
                                  <td>
                                    <IconButton
                                      className="task-buttons"
                                      onClick={() => handleOpenSubtaskDetailsModal(subtask)}
                                    >
                                      <MenuIcon />
                                    </IconButton>
                                  </td>
                                  <td>{subtask.title}</td>
                                  <td>{new Date(subtask.due_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                  <td>{subtaskAssignedTo}</td>
                                  <td>{subtaskAssignedBy}</td>
                                  <td>
                                    <IconButton onClick={() => handleOpenDeleteModal('subtask', subtask)}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr className="no-subtasks-row">
                              <td colSpan="6">{t('tasksx.noSubtasksAvailable')}</td>
                            </tr>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
            {/* Other Tasks Pagination */}
            <Pagination
              totalItems={totalOverdueTasks}
              itemsPerPage={itemsPerPage}
              currentPage={currentPages.overdue}
              onPageChange={(page) => handlePageChange('overdue', page)}
            />
          </Box>
        )}

      </Box>
      {/* Invite User Modal */}
      <Modal open={inviteModalOpen} onClose={() => setInviteModalOpen(false)}>
        <Box
          style={{
            backgroundColor: 'white',
            padding: '20px',
            margin: '50px auto',
            width: '400px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Typography variant="h5" gutterBottom>
            {t('inviteUser.title')}
          </Typography>
          <form onSubmit={handleInvite}>
            <TextField
              label={t('inviteUser.userEmail')}
              fullWidth
              margin="normal"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
            />
            <Button variant="contained" color="primary" type="submit" fullWidth>
              {t('inviteUser.sendInvitation')}
            </Button>
            {inviteMessage && <Typography color="error">{inviteMessage}</Typography>}
          </form>
        </Box>
      </Modal>

      {/* Create Team Modal */}
      <Modal open={teamModalOpen} onClose={() => setTeamModalOpen(false)}>
        <Box
          style={{
            backgroundColor: 'white',
            padding: '20px',
            margin: '50px auto',
            width: '400px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Typography variant="h5" gutterBottom>
            {t('createTeam.title')}
          </Typography>
          <form onSubmit={handleCreateTeam}>
            <TextField
              label={t('createTeam.teamName')}
              fullWidth
              margin="normal"
              value={teamName}
              onChange={(e) => setTeamName(e.target.value)}
            />
            <TextField
              label={t('createTeam.teamDescription')}
              fullWidth
              margin="normal"
              value={teamDescription}
              onChange={(e) => setTeamDescription(e.target.value)}
            />
            <Button variant="contained" color="primary" type="submit" fullWidth>
              {t('createTeam.createButton')}
            </Button>
            {teamMessage && <Typography color="error">{teamMessage}</Typography>}
          </form>
        </Box>
      </Modal>

      {/* Team Members Modal */}
      <Modal open={modalOpen && modalType === 'viewTeam'} onClose={handleCloseModal}>
        <Box style={{ backgroundColor: 'white', padding: '20px', margin: '50px auto', width: '400px', maxHeight: '400px', overflowY: 'auto' }}>
          <Typography variant="h5" gutterBottom>
            Team Members
          </Typography>
          <List>
            {teamMembers.map(member => (
              <ListItem key={member.id}>
                <ListItemText primary={member.name} secondary={member.email} />
              </ListItem>
            ))}
          </List>
          <Button onClick={handleCloseModal} variant="contained" color="primary" fullWidth>
            Close
          </Button>
        </Box>
      </Modal>

      {/* Edit Team Modal */}
      <Modal open={modalOpen && modalType === 'editTeam'} onClose={handleCloseModal}>
        <Box style={{ backgroundColor: 'white', padding: '20px', margin: '50px auto', width: '400px' }}>
          <Typography variant="h5" gutterBottom>
            Edit Team
          </Typography>
          <form onSubmit={handleEditTeam}>
            <TextField
              label="Team Name"
              fullWidth
              margin="normal"
              value={teamName}
              onChange={(e) => setTeamName(e.target.value)}
            />
            <TextField
              label="Team Description"
              fullWidth
              margin="normal"
              value={teamDescription}
              onChange={(e) => setTeamDescription(e.target.value)}
            />
            <Button variant="contained" color="primary" type="submit" fullWidth>
              Save Changes
            </Button>
          </form>
        </Box>
      </Modal>

      {/* Delete Team Modal */}
      <Modal open={modalOpen && modalType === 'deleteTeam'} onClose={handleCloseModal}>
        <Box style={{ backgroundColor: 'white', padding: '20px', margin: '50px auto', width: '400px' }}>
          <Typography variant="h5" gutterBottom>
            Confirm Deletion
          </Typography>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to delete this team? This action cannot be undone.
          </Typography>
          <Button onClick={confirmDeleteTeam} variant="contained" color="secondary" fullWidth>
            Delete
          </Button>
          <Button onClick={handleCloseModal} variant="contained" color="primary" fullWidth>
            Cancel
          </Button>
        </Box>
      </Modal>

      {/* Delete Member Modal */}
      <Modal open={deleteMemberModalOpen} onClose={handleCloseDeleteMemberModal}>
        <Box style={{ backgroundColor: 'white', padding: '20px', margin: '50px auto', width: '400px' }}>
          <Typography variant="h5" gutterBottom>
            Confirm Deletion
          </Typography>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to remove this member from the project? This action cannot be undone.
          </Typography>
          <Button onClick={confirmDeleteMember} variant="contained" color="secondary" fullWidth>
            Delete
          </Button>
          <Button onClick={handleCloseDeleteMemberModal} variant="contained" color="primary" fullWidth>
            Cancel
          </Button>
        </Box>
      </Modal>


      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t('deleteConfirmation.title')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {selectedTask
              ? t('deleteConfirmation.taskMessage', { taskTitle: selectedTask.title })
              : t('deleteConfirmation.subtaskMessage', { subtaskTitle: selectedSubtask?.title })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" disabled={isProcessing}>
            {t('deleteConfirmation.cancel')}
          </Button>
          <Button
            onClick={() =>
              handleDelete(
                selectedTask ? 'task' : 'subtask',
                selectedTask ? selectedTask.id : selectedSubtask?.id
              )
            }
            color="secondary"
            disabled={isProcessing}
          >
            {isProcessing ? t('deleteConfirmation.deleting') : t('deleteConfirmation.delete')}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Mesaj Gösterimi */}
      {message && (
        <Alert severity={message.type} onClose={() => setMessage('')}>
          {message.text}
        </Alert>
      )}

      {/* Create Task Modal */}
      <CreateTaskForm
        open={taskModalOpen}
        projectId={projectId}
        members={members}
        teams={teams}
        currentUserId={currentUserId}
        currentUserRoleId={userRoleId}
        onClose={handleCloseModal}
        updateTasks={setTasks}
        refreshData={refreshTasks}
      />

      {/* Assign Role or Team Modal */}
      <AssignRoleOrTeam
        open={modalOpen && (modalType === 'role' || modalType === 'team')}
        onClose={handleCloseModal}
        projectId={projectId}
        memberId={selectedMember}
        type={modalType}
        refreshData={fetchProject}
      />


      {/* Create/Edit Subtask Modal */}
      <CreateSubtaskForm
        open={subtaskModalOpen}
        projectId={projectId}
        members={members}
        teams={teams}
        currentUserId={currentUserId}
        currentUserRoleId={userRoleId}
        task={selectedTask}
        subtask={selectedSubtask}
        onClose={handleCloseSubtaskModal}
        onSave={handleCreateSubtask}
        refreshData={refreshTasks}

        errorMessage={subtaskErrorMessage}  // Hata mesajını buradan ileteceğiz
      />
      {/* DetailsForm modal */}

      <DetailsForm
        task={selectedTask}
        subtask={selectedSubtask}
        open={detailsModalOpen}
        teams={teams}
        subtaskMainTaskTeamId={subtaskMainTaskTeamId}
        onClose={() => setDetailsModalOpen(false)}
        projectId={projectId}
        currentUserRoleId={userRoleId}
        detailsTab={detailsTab}
        refreshData={refreshTasks}
      />
      {/* Invite User Modal */}
      <Modal open={inviteModalOpen} onClose={() => setInviteModalOpen(false)}>
        <Box
          sx={{
            backgroundColor: 'white',
            padding: '20px',
            margin: '50px auto',
            width: '400px',
            borderRadius: '8px',
            boxShadow: 3,
          }}
        >
          <Typography variant="h5" gutterBottom>
            {t('inviteUser.title')}
          </Typography>
          <form onSubmit={handleInvite}>
            <TextField
              label={t('inviteUser.emailLabel')}
              fullWidth
              margin="normal"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
            />
            <Button variant="contained" color="primary" type="submit" fullWidth>
              {t('inviteUser.sendInvitation')}
            </Button>
            {inviteMessage && <Typography color="error">{inviteMessage}</Typography>}
          </form>
        </Box>
      </Modal>

      {/* Expenses Modal */}
      <Modal open={expensesModalOpen} onClose={() => setExpensesModalOpen(false)}>
        <Box
          sx={{
            backgroundColor: 'white',
            padding: '20px',
            margin: '5% auto',
            width: '90%',
            maxWidth: '600px',
            height: '80%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            boxShadow: 3,
          }}
        >
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {t('expensesx.title')}
            </Typography>
            <Typography>
              {t('expensesx.totalBudget')}: {project?.currency} {project?.total_budget || t('expensesx.notSet')}
            </Typography>
            <Typography>
              {t('expensesx.totalExpenses')}: {project?.currency} {expenses.reduce((sum, expense) => sum + Number(expense.amount), 0).toFixed(2)}
            </Typography>
          </Box>

          {/* Add Expense Form */}
          <Box sx={{ marginBottom: '20px', marginTop: '10px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
              {/* Expense Name */}
              <TextField
                label={t('expensesx.expenseName')}
                value={newExpenseName}
                onChange={(e) => setNewExpenseName(e.target.value)}
                margin="normal"
                sx={{ flex: '1 1 45%' }}
              />

              {/* Expense Amount */}
              <TextField
                label={t('expensesx.expenseAmount')}
                type="number"
                value={newExpenseAmount}
                onChange={(e) => setNewExpenseAmount(e.target.value)}
                margin="normal"
                sx={{ flex: '1 1 25%' }}
              />

              {/* Category Selection */}
              <Select
                value={selectedCategory || ''}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === 'add-new') {
                    setAddingNewCategory(true);
                    setSelectedCategory('');
                  } else {
                    setAddingNewCategory(false);
                    setSelectedCategory(value);
                  }
                }}
                displayEmpty
                sx={{ flex: '1 1 25%' }}
              >
                <MenuItem value="" disabled>
                  {t('expensesx.selectCategory')}
                </MenuItem>
                {expenseCategories.map((category) => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.name}
                  </MenuItem>
                ))}
                <MenuItem value="add-new" sx={{ fontStyle: 'italic' }}>
                  {t('expensesx.addNewCategory')}
                </MenuItem>
              </Select>
            </Box>

            {/* Add New Category Input */}
            {addingNewCategory && (
              <Box sx={{ marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                <TextField
                  placeholder={t('expensesx.newCategoryPlaceholder')}
                  value={newCategoryName}
                  onChange={(e) => setNewCategoryName(e.target.value)}
                  fullWidth
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddCategory}
                  disabled={!newCategoryName.trim()}
                >
                  {t('expensesx.saveCategory')}
                </Button>
              </Box>
            )}

            {/* Task Selection */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
              <Select
                value={selectedExpenseTask || ''}
                onChange={(e) => setSelectedExpenseTask(e.target.value)}
                displayEmpty
                sx={{ flex: 1 }}
              >
                <MenuItem value="">{t('expensesx.selectTask')}</MenuItem>
                {expenseTaskList.map((task) => (
                  <MenuItem key={task.id} value={task.id}>
                    {task.title}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            {/* Add Expense Button */}
            {!addingNewCategory && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddExpense}
                sx={{ marginTop: '10px' }}
                disabled={!newExpenseName.trim() || !newExpenseAmount || !selectedCategory}
              >
                {t('expensesx.addExpense')}
              </Button>
            )}
          </Box>

          {/* Expenses List */}
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              border: '1px solid #ccc',
              borderRadius: '8px',
              padding: '10px',
            }}
          >
            <Typography variant="h6" gutterBottom>
              {t('expensesx.expenseList')}
            </Typography>
            <List>
              {expenses.length > 0 ? (
                expenses.map((expense, index) => {
                  const categoryName =
                    expenseCategories.find((category) => category.id === expense.category_id)?.name || t('expenses.uncategorized');
                  const taskTitle =
                    expenseTaskList.find((task) => task.id === expense.task_id)?.title || t('expenses.none');

                  return (
                    <ListItem
                      key={index}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        border: '1px solid #eee',
                        borderRadius: '8px',
                        marginBottom: '10px',
                        padding: '10px',
                        boxShadow: 3,
                      }}
                    >
                      <Typography sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
                        {expense.name}
                      </Typography>
                      <Typography sx={{ fontSize: '0.9rem' }}>
                        {`${expense?.description || ''} | ${t('expensesx.amount')}: ${project?.currency} ${expense.amount} | ${t('expensesx.category')}: ${categoryName} | ${t('expensesx.task')}: ${taskTitle}`}
                      </Typography>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => handleOpenDeleteExpenseDialog(expense)}
                        sx={{ marginTop: '10px', alignSelf: 'flex-end' }}
                      >
                        {t('expensesx.delete')}
                      </Button>
                    </ListItem>
                  );
                })
              ) : (
                <Typography>{t('expensesx.noExpenses')}</Typography>
              )}
            </List>

            {/* Confirmation Dialog */}
            <Dialog open={openDeleteExpenseDialog} onClose={handleCloseDeleteExpenseDialog}>
              <DialogTitle>{t('expensesx.confirmDeletion')}</DialogTitle>
              <DialogContent>
                <Typography>
                  {t('expensesx.confirmDeleteMessage', { name: selectedExpense?.description })}
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDeleteExpenseDialog} color="primary">
                  {t('expensesx.cancel')}
                </Button>
                <Button onClick={handleConfirmDelete} color="error">
                  {t('expensesx.delete')}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Box>
      </Modal>
      {/* Risk Management Modal */}
      <Modal open={risksModalOpen} onClose={() => setRisksModalOpen(false)}>
        <Box
          sx={{
            backgroundColor: 'white',
            padding: '20px',
            margin: '5% auto',
            width: '90%',
            maxWidth: '600px',
            height: '80%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '8px',
            boxShadow: 3,
          }}
        >
          {/* Header */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {t('risks.title')}
            </Typography>
            <Typography>
              {t('risks.total')}: {risks.length}
            </Typography>
          </Box>

          {/* Add Risk Form */}
          <Box sx={{ marginBottom: '20px', marginTop: '10px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
              {/* Risk Name */}
              <TextField
                label={t('risks.riskName')}
                value={newRiskName}
                onChange={(e) => setNewRiskName(e.target.value)}
                margin="normal"
                sx={{ flex: '1 1 45%' }}
              />

              {/* Likelihood */}
              <Select
                value={newRiskLikelihood}
                onChange={(e) => setNewRiskLikelihood(e.target.value)}
                displayEmpty
                sx={{ flex: '1 1 25%' }}
              >
                <MenuItem value="" disabled>
                  {t('risks.likelihood')}
                </MenuItem>
                <MenuItem value="Low">{t('risks.low')}</MenuItem>
                <MenuItem value="Medium">{t('risks.medium')}</MenuItem>
                <MenuItem value="High">{t('risks.high')}</MenuItem>
              </Select>

              {/* Impact */}
              <Select
                value={newRiskImpact}
                onChange={(e) => setNewRiskImpact(e.target.value)}
                displayEmpty
                sx={{ flex: '1 1 25%' }}
              >
                <MenuItem value="" disabled>
                  {t('risks.impact')}
                </MenuItem>
                <MenuItem value="Low">{t('risks.low')}</MenuItem>
                <MenuItem value="Medium">{t('risks.medium')}</MenuItem>
                <MenuItem value="High">{t('risks.high')}</MenuItem>
              </Select>

              {/* Category Selection */}
              <Select
                value={selectedRiskCategory || ''}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === 'add-new') {
                    setAddingNewRiskCategory(true);
                    setSelectedRiskCategory('');
                  } else {
                    setAddingNewRiskCategory(false);
                    setSelectedRiskCategory(value);
                  }
                }}
                displayEmpty
                sx={{ flex: '1 1 25%' }}
              >
                <MenuItem value="" disabled>
                  {t('risks.selectCategory')}
                </MenuItem>
                {riskCategories.map((category) => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.name}
                  </MenuItem>
                ))}
                <MenuItem value="add-new" sx={{ fontStyle: 'italic' }}>
                  {t('risks.addNewCategory')}
                </MenuItem>
              </Select>
            </Box>

            {/* Add New Category Input */}
            {addingNewRiskCategory && (
              <Box sx={{ marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                <TextField
                  placeholder={t('risks.newCategoryPlaceholder')}
                  value={newRiskCategoryName}
                  onChange={(e) => setNewRiskCategoryName(e.target.value)}
                  fullWidth
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddRiskCategory}
                  disabled={!newRiskCategoryName.trim()}
                >
                  {t('risks.saveCategory')}
                </Button>
              </Box>
            )}

            {/* Description */}
            <TextField
              label={t('risks.description')}
              value={newRiskDescription}
              onChange={(e) => setNewRiskDescription(e.target.value)}
              margin="normal"
              fullWidth
              multiline
              rows={2}
            />

            {/* Task Selection */}
            <Select
              value={selectedRiskTask || ''}
              onChange={(e) => setSelectedRiskTask(e.target.value)}
              displayEmpty
              sx={{ marginTop: '10px', width: '100%' }}
            >
              <MenuItem value="">{t('risks.selectTask')}</MenuItem>
              {riskTaskList.map((task) => (
                <MenuItem key={task.id} value={task.id}>
                  {task.title}
                </MenuItem>
              ))}
            </Select>

            {/* Add Risk Button */}
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddRisk}
              sx={{ marginTop: '10px' }}
              disabled={!newRiskName.trim() || !newRiskLikelihood || !newRiskImpact || !selectedRiskCategory}
            >
              {t('risks.addRisk')}
            </Button>
          </Box>

          {/* Risk List */}
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              border: '1px solid #ccc',
              borderRadius: '8px',
              padding: '10px',
            }}
          >
            <Typography variant="h6" gutterBottom>
              {t('risks.riskList')}
            </Typography>
            <List>
              {risks.length > 0 ? (
                risks.map((risk, index) => {
                  // Risk Seviyesini Hesapla
                  const riskLevel = calculateRiskLevel(risk.likelihood, risk.impact);

                  // Risk Seviyesi Renk Kodları
                  const getRiskLevelColor = (level) => {
                    if (level >= 6) return '#f44336'; // High Risk (Kırmızı)
                    if (level >= 3) return '#ffc107'; // Medium Risk (Sarı)
                    return '#4caf50'; // Low Risk (Yeşil)
                  };

                  // Status Renk Kodları
                  const getStatusColor = (status) => {
                    switch (status) {
                      case 'Open':
                        return '#4caf50'; // Yeşil
                      case 'In Progress':
                        return '#ffc107'; // Sarı
                      case 'Mitigated':
                        return '#2196f3'; // Mavi
                      case 'Resolved':
                        return '#8e44ad'; // Mor
                      case 'Accepted':
                        return '#795548'; // Kahverengi
                      case 'Closed':
                        return '#f44336'; // Kırmızı
                      default:
                        return '#9e9e9e'; // Gri (Diğer durumlar)
                    }
                  };

                  const riskColor = getRiskLevelColor(riskLevel);
                  const statusColor = getStatusColor(risk.status);

                  return (
                    <ListItem
                      key={index}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        border: '1px solid #eee',
                        borderRadius: '8px',
                        marginBottom: '10px',
                        padding: '10px',
                        boxShadow: 2,
                      }}
                    >
                      {editingRiskId === risk.id ? (
                        <>
                          {/* Düzenleme Alanı */}
                          <Box sx={{ width: '100%' }}>
                            <InputLabel sx={{ marginBottom: '5px', color: 'black' }}>
                              {t('risks.status')}
                            </InputLabel>
                            <Select
                              value={updatedRisk.status || ''}
                              onChange={(e) => handleRiskChange('status', e.target.value)}
                              sx={{ marginBottom: '10px', width: '100%', color: 'black' }}
                            >
                              {statusOptions.map((status) => (
                                <MenuItem key={status} value={status}>
                                  {t(`risks.statusOptions.${status}`)}
                                </MenuItem>
                              ))}
                            </Select>
                          </Box>
                          <TextField
                            label={t('risks.riskName')}
                            value={updatedRisk.name || ''}
                            onChange={(e) => handleRiskChange('name', e.target.value)}
                            sx={{ marginBottom: '10px', width: '100%' }}
                          />
                          <TextField
                            label={t('risks.description')}
                            value={updatedRisk.description || ''}
                            onChange={(e) => handleRiskChange('description', e.target.value)}
                            sx={{ marginBottom: '10px', width: '100%' }}
                            multiline
                            rows={2}
                          />
                          <div style={{ display: 'flex', gap: '10px' }}>
                            <Button variant="contained" color="primary" onClick={handleSaveRiskClick}>
                              {t('risks.save')}
                            </Button>
                            <Button variant="outlined" color="secondary" onClick={handleCancelRiskClick}>
                              {t('risks.cancel')}
                            </Button>
                          </div>
                        </>
                      ) : (
                        <>
                          {/* Normal Görünüm */}
                          <Typography sx={{ fontWeight: 'bold', fontSize: '1rem' }}>{risk.name}</Typography>
                          <Typography sx={{ fontSize: '0.9rem' }}>
                            {t('risks.description')}: {risk.description || t('risks.notAvailable')} |{' '}
                            {t('risks.likelihood')}: {t(`risks.likelihoodLevels.${risk.likelihood}`)} |{' '}
                            {t('risks.impact')}: {t(`risks.impactLevels.${risk.impact}`)} |{' '}
                            {t('risks.category')}:{' '}
                            {riskCategories.find((cat) => cat.id === risk.category_id)?.name || t('risks.uncategorized')}
                          </Typography>
                          {/* Risk Level */}
                          <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold', color: riskColor, marginTop: '5px' }}>
                            {t('risks.riskLevel')}: {riskLevel} ({t(`risks.riskLevels.${riskLevel >= 6 ? 'high' : riskLevel >= 3 ? 'medium' : 'low'}`)})
                          </Typography>
                          {/* Status */}
                          <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold', color: statusColor, marginTop: '5px' }}>
                            {t('risks.status')}: {t(`risks.statusOptions.${risk.status}`)}
                          </Typography>
                          <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                            <Button variant="outlined" color="primary" onClick={() => handleEditRiskClick(risk)}>
                              {t('risks.edit')}
                            </Button>
                            <Button variant="outlined" color="error" onClick={() => handleOpenDeleteRiskDialog(risk)}>
                              {t('risks.delete')}
                            </Button>
                          </div>
                        </>
                      )}
                    </ListItem>
                  );
                })
              ) : (
                <Typography>{t('risks.noRisks')}</Typography>
              )}
            </List>
          </Box>
          {/* Confirmation Dialog */}
          <Dialog open={openDeleteRiskDialog} onClose={handleCloseDeleteRiskDialog}>
            <DialogTitle>{t('risks.confirmDeletion')}</DialogTitle>
            <DialogContent>
              <Typography>
                {t('risks.confirmDeletionMessage', { riskName: selectedRisk?.name })}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDeleteRiskDialog} color="primary">
                {t('risks.cancel')}
              </Button>
              <Button onClick={handleConfirmDeleteRisk} color="error">
                {t('risks.delete')}
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Modal>

    </Container>
  );
};

export default ProjectDetails;
